import { GlobalObject } from './../../models/business/global-object';
import { CommunicationParameter } from './../communication/communication.interface';
import { RecordLine } from 'src/app/layout/record-model';
import { RecordCategory, RecordProperties } from './../record-model';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ModuleInformation } from 'src/app/models/module-information';
import { switchMap, tap, map } from 'rxjs/operators';
import * as Handlebars from 'handlebars';
import * as g from 'src/app/globals';
import { AdditionalButton } from './../../models/additional-button';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ComponentRef,
} from '@angular/core';
import { LayoutService } from '../layout.service';
import { FieldValueChangedArgs } from '../field-value-changed-args';
import {
  Action,
  ApprovalTemplate,
  EventType,
  RecordModel,
  SourceDocument,
} from '../record-model';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ModuleStructure,
  SectionGroup,
  Section,
  Values,
  Field,
  FieldDataType,
} from 'src/app/models/module-structure';
import { RecordPageArgs } from 'src/app/models/record-page-args';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import * as businessDoc from '../../models/business/documents';
import * as businessPayment from '../../models/business/payments';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { interval, Subscription, Observable, pipe, forkJoin } from 'rxjs';
import { DocumentsService } from 'src/app/apps/documents/documents.service';
import {
  ChangedValueModelActionType,
  CustomActionResult,
} from 'src/app/models/CustomActionResult';
import { BillOfMaterials } from '@app/models/business/billOfMaterials';
import { LoadingService } from '@app/services/loading.service';
import { BillOfMaterialService } from '@app/services/BillOfMaterial.service';
import { Guid } from '@app/models/guid';
import { OffloadMappingComponent } from './custom-buttons/offload-mapping/offload-mapping.component';

@Component({
  selector: 'app-record-page',
  templateUrl: './record-page.component.html',
  styleUrls: ['./record-page.component.less'],
})
export class RecordPageComponent implements OnInit, OnDestroy {
  private componentRef: ComponentRef<any>;

  @Input() moduleId: number;

  recordIdVal: string | number;
  saveToFinalDocConfig: boolean;
  showSaveTofinalButtonConfig = true;
  @Input() set recordId(val: string | number) {
    this.recordIdVal = val;
  }

  get recordId(): string | number {
    return this.recordIdVal;
  }

  keyToDisplay = '';

  @Input() actionType: string;
  @Input() moduleActionType: number;
  @Input() sourceObject: number;
  @Input() sourceObjectId: string | number;
  @Input() BPCardCode: string;
  @Input() items: string;
  @Input() customActionCode: string;
  @Input() inModuleList: boolean;
  @Input() initValues?: CustomActionResult[];
  @Input() contactId: string;
  @Input() inDrawer = false;
  @Input() isTokenized = false;
  @Input() showComments = true;
  @Input() showCommunication = true;
  @Input() inputValues: Values = {};
  @Input() recordModel: RecordModel;
  @Input() parentRecordModel: RecordModel;
  @Input() additionalButtons: AdditionalButton[];
  @Input() autoSubmit = false;
  @Input() footerAtTop = false;
  @Input() hideFooter = false;
  @Input() fromDraft: boolean = false;
  @Input() fromLog: boolean = false;
  @Input() logInstance: number = 0;
  @Input() fromDoc: boolean = false;
  @Input() linkedField: string = '';
  @Input() additionalSectionsIndex = -1;

  @Input() urlPrefix: string = '';
  @Input() moduleFilterId = 0;

  @Output() recordModelChange = new EventEmitter<RecordModel>();

  @Output() backButtonClicked = new EventEmitter();
  @Output() objectSubmitted: EventEmitter<string> = new EventEmitter<string>();
  @Output() finishLoaded: EventEmitter<RecordModel> =
    new EventEmitter<RecordModel>();
  documentHead: RecordLine[];
  timer: any;
  thereIsResult: {
    thereIsResult: boolean;
    isError: boolean;
    errorMessage: string;
  } = { thereIsResult: false, isError: false, errorMessage: '' };
  ShowCommentsConfig = false;
  moduleStructure: ModuleStructure;
  sections: SectionGroup[];
  defaultVals: Values;
  isLoading = true;
  isError = false;
  isForeignCurr = false;
  errorMessage = '';
  xmlData = '';
  fields: Field[];
  actions: Action[];
  commentShowHide = true;
  submitting = false;
  submittingModel = false;
  removing = false;
  screenSize: string;
  buttonSections: any[];
  normalSections: SectionGroup[];
  drawerSections: any[];
  moduleInformation: ModuleInformation;
  approvalTemplates: ApprovalTemplate[];
  showApproveDrawer = false;
  showSaveTofinalButton = false;
  showSubmitButton = true;
  showAddAgain = false;
  showCopyFromButton = false;
  showSuccessArea = false;
  documentSources: SourceDocument[];
  addressIsSetfromOAT = false;
  addressIsSetfromDoc = false;
  fieldShouldCopyIsSetfromDoc = false;

  openDocumentRows: any[];
  additionalFieldsCopyFromPOR: any[] = [];
  additionalFieldsCopyFromPCH: any[] = [];
  additionalFieldsCopyFromQUT: any[] = [];
  displayQuoteNameForQUT = false;
  displaySalesSourceForQUT = false;
  salesSourceOptions: any[] = [];
  minimizedOpenDocumentRows: any[];
  minimizedOpenDocumentRowsForBA: any[];
  displayMinimizedRows = false;
  filters = {
    docNum: '',
    itemCode: '',
    description: '',
    numAtCard: '',
    quotName: '',
    salesSource: '',
  };
  filteredData: any[] = [];

  //for blanketAgreement
  //copiedQuotEntries: string[] = [];
  //end

  showCopyFromDrawer = false;
  documentType = '';
  maxLineNum = 0;
  comment = '';
  ObjectCode = 0;
  activitiesData = [];
  resultMessage = '';
  commentEmailSub = '';
  commentEmailBody = '';
  Identity = g.userIdentity;
  communicationParameters: CommunicationParameter = {
    Bcc: [],
    Cc: [],
    HtmlBody: '',
    ITM_HELP_ISPUP: true,
    Subject: '',
    To: [],
    fromCommunication: false,
    trackData: false,
  };
  salesPerson: any;
  subscriptions: Subscription[] = [];
  sectionsUpdated = false;

  parentItemCode = '';
  allowUpdateWnenClose = false;

  constructor(
    private notificationService: NzNotificationService,
    private message: NzMessageService,
    private modal: NzModalService,
    private layoutService: LayoutService,
    private route: ActivatedRoute,
    private drawerService: NzDrawerService,
    private documentsService: DocumentsService,
    private router: Router,
    private loadingService: LoadingService,
    private billOfMaterialService: BillOfMaterialService,
  ) {}

  static openRecordPage(drawerService: NzDrawerService, args: RecordPageArgs) {
    const subs: Subscription[] = [];
    const drawerRef = drawerService.create<RecordPageComponent>({
      nzTitle: args.drawerTitle,
      nzWrapClassName: 'drawer-size-4x drawer-body-no-padding',
      nzContent: RecordPageComponent,
      nzContentParams: {
        moduleId: args.moduleId,
        sourceObject: args.sourceModuleId,
        moduleActionType: args.moduleActionType,
        sourceObjectId: args.sourceRecordId,
        inDrawer: args.inDrawer,
        recordId: args.recordId,
        recordModel: args.recordModel,
        actionType: args.actionType,
        inputValues: args.inputValues,
        parentRecordModel: args.parentRecordModel,
        customActionCode: args.customActionCode,
        initValues: args.initValues,
        fromDraft: args.fromDraft,
        fromLog: args.fromLog,
        logInstance: args.logInstance,
        linkedField: args.linkedField,
        footerAtTop: true,
      },
    });

    drawerRef.afterClose.subscribe(() => {
      try {
        if (args.parentComponent.recordPageDrawerClosed !== undefined) {
          args.parentComponent.recordPageDrawerClosed();
        }
        afterOpen.unsubscribe();
        submitted.unsubscribe();
        drawerRef.getContentComponent().destroy();
      } catch (e) {
        console.log(e);
      }
    });

    let submitted: Subscription;
    const afterOpen = drawerRef.afterOpen.subscribe(() => {
      const recordPageComponent = drawerRef.getContentComponent();
      recordPageComponent.backButtonClicked.subscribe(() => {
        //console.log(args.recordModel.ThereIsChange);
        drawerRef.close();
        if (
          args.recordId != null &&
          args.parentComponent.reloadTheRecords !== undefined
        ) {
          args.parentComponent.reloadTheRecords();
        }
      });
      submitted = recordPageComponent.objectSubmitted.subscribe(($event) => {
        if (args.parentComponent?.linkedObjectSubmitted) {
          args.parentComponent.linkedObjectSubmitted($event, args);
        }

        if (args.actionType?.toLowerCase() === 'add') {
          drawerRef.close();
        }
      });

      // recordPageComponent.mo
    });
  }

  logRecordModel(): void {
    console.log('recordModel ==> ', this.recordModel);
  }

  activitiesList() {
    this.isLoading = true;
    this.timer = setInterval(() => {
      const activities$ = this.layoutService
        .activitiesList(this.recordModel.ObjectTypeValue, this.recordId)
        .subscribe((result: { rows: Array<any> }) => {
          let chkGrp: any[] = [];
          const children: any[] = [];
          for (const key in result.rows) {
            if (result.rows && result.rows[key].U_ITM_HELP_ISPUP === 'Y') {
              chkGrp.push(result.rows[key]);
            }
          }
          chkGrp = chkGrp.sort((a, b) => {
            const dataA = new Date(a.Recontact);
            const dataB = new Date(b.Recontact);
            if (dataA > dataB) {
              return -1;
            } else if (dataA < dataB) {
              return 1;
            } else {
              return 0;
            }
          });
          this.activitiesData = chkGrp;
          // this.isLoading = false;
        });
      this.subscriptions.push(activities$);
    }, 15000);
    // interval(5000).subscribe((x) => {
    // });
  }

  getEmail(head: RecordLine, temp: string) {
    if (head !== undefined) {
      const template = Handlebars.compile(temp);

      const html = template(head);

      return html;
    }
  }

  addDocComment() {
    if (this.comment === '') {
      this.message.error(
        this.layoutService.translate(
          'pelase write some text in the comment area',
        ),
      );
    } else {
      const data = {
        token: g.getToken(),
        notes: this.comment,
        emailSubject: 'New Comment Added ',
        emailBody: `${this.commentEmailBody} \r \n \t ${this.comment}`,
      };
      const postComment$ = this.layoutService
        .postComment(
          this.moduleId,
          this.recordModel.KeyValue,
          +this.recordModel.ObjectTypeValue,
          this.comment,
          data.emailSubject,
          data.emailBody,
        )
        .subscribe((commentData: any) => {
          if (!commentData.Has_Error) {
            this.comment = '';
            this.message.success(this.layoutService.translate('Comment added'));
          } else {
            this.comment = '';
            this.notificationService.error('Error', commentData.Error_Message, {
              nzDuration: 5000,
            });
          }
          console.log(commentData);
        });
      this.subscriptions.push(postComment$);
    }
  }

  destroy() {
    if (this.componentRef) {
      console.log(":( you've destroyed me :(");

      this.componentRef.destroy();
    }
  }

  ngAfterContentInit(): void {
    this.finishLoaded.emit(this.recordModel);
  }

  ngOnDestroy(): void {
    this.normalSections = undefined;
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
    console.log(`${this.subscriptions.length} subscriptions unsubscribed`);

    clearInterval(this.timer);
    this.layoutService.recordModelChanged = false;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showSubmitButton = true;
    });
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.loadingService.requestsInFlight$.subscribe((count) => {
        this.submitting = count > 0;
      }),
    );

    this.subscriptions.push(
      /*this.route.params.subscribe((params) => {
        if (params.fromDraft) {
          //this.fromDraft = params.fromDraft;
          this.fromDraft =
            params.fromDraft === true || params.fromDraft === 'true';
        }
        if (params.fromDoc) {
          this.fromDoc = params.fromDoc;
        }
        if (params.inDrawer) {
          this.inDrawer =
            params.inDrawer === true || params.inDrawer === 'true';
        } else {
          //this.inDrawer = false;
        }
      }),*/

      this.route.params.subscribe((params) => {
        this.fromDraft =
          params.fromDraft === true || params.fromDraft === 'true';

        if (this.recordModel !== undefined) {
          this.recordModel.FromDraft = this.fromDraft;
        }
        if (params.fromDoc) {
          this.fromDoc = params.fromDoc;
        }

        //this.inDrawer = params.inDrawer === true || params.inDrawer === 'true';
        if (params.inDrawer) {
          this.inDrawer =
            params.inDrawer === true || params.inDrawer === 'true';
        } else {
          //this.inDrawer = false;
        }
      }),
    );

    this.layoutService
      .getConfiguration('config_show_save_to_final')
      .subscribe((response) => {
        this.showSaveTofinalButtonConfig = response === 'Y' || response == '';
      });

    this.normalSections = new Array<any>();
    this.sections = new Array<any>();

    if (
      g.additionalFieldsCopyFromPOR != null &&
      g.additionalFieldsCopyFromPOR !== undefined &&
      g.additionalFieldsCopyFromPOR !== ''
    ) {
      this.additionalFieldsCopyFromPOR = JSON.parse(
        g.additionalFieldsCopyFromPOR,
      );
    }
    if (
      g.additionalFieldsCopyFromPCH != null &&
      g.additionalFieldsCopyFromPCH !== undefined &&
      g.additionalFieldsCopyFromPCH !== ''
    ) {
      this.additionalFieldsCopyFromPCH = JSON.parse(
        g.additionalFieldsCopyFromPCH,
      );
    }
    if (
      g.additionalFieldsCopyFromQUT != null &&
      g.additionalFieldsCopyFromQUT !== undefined &&
      g.additionalFieldsCopyFromQUT !== ''
    ) {
      this.additionalFieldsCopyFromQUT = JSON.parse(
        g.additionalFieldsCopyFromQUT,
      );
    }

    this.displayQuoteNameForQUT = g.displayQuoteNameForQUT;
    this.displaySalesSourceForQUT = g.displaySalesSourceForQUT;
    if (g.salesSourceFilterQryId && g.salesSourceFilterQryId !== 0) {
      const salesSourceOptions$ = this.layoutService
        .executeQuery(g.salesSourceFilterQryId, {})
        .subscribe((result: any[]) => {
          this.salesSourceOptions = result;
        });
      this.subscriptions.push(salesSourceOptions$);
    }

    this.openDocumentRows = [];
    this.minimizedOpenDocumentRows = [];
    this.minimizedOpenDocumentRowsForBA = [];
    this.filteredData = [];

    this.approvalTemplates = [];
    this.showCopyFromDrawer = false;
    this.showSaveTofinalButton = false;
    this.showSubmitButton = true;
    this.showAddAgain = false;
    this.showCopyFromButton = false;
    this.screenSize = this.layoutService.screenSize;
    this.actions = [];
    const screenSize$ = this.layoutService.screenSizeEmitter.subscribe((a) => {
      this.screenSize = a;
    });
    if (!this.isTokenized) {
      this.layoutService
        .moduleInformation(this.moduleId.toString())
        .pipe(
          tap((information: ModuleInformation) => {
            this.moduleInformation = information;
          }),
          switchMap(() => this.layoutService.getActions(this.moduleId)),
          tap((actions: Action[]) => {
            this.actions = actions;
          }),
        )
        .subscribe();
      this.subscriptions.push(screenSize$);
    }

    if (
      this.moduleStructure != null &&
      this.sections != null &&
      this.moduleStructure.module.Id === this.moduleId
    ) {
      this.buttonSections = this.getButtonSections(this.sections);
      this.normalSections = this.getNormalSections(
        this.moduleStructure.module.Sections,
      );
      this.drawerSections = this.getDrawerSections(
        this.moduleStructure.module.Sections,
      );
      this.commentEmailSub = 'Comment added';
      this.commentEmailBody = `Comment added to ${this.moduleStructure.module.PluralName} No. {{prop 'DocNum'}}.`;
      this.initializeRecordModel();
    } else {
      const moduleStructure$ = this.layoutService
        .getModuleStructure(this.moduleId)
        .subscribe((d: any) => {
          if (d.IsError !== undefined && d.IsError === true) {
            this.isError = true;
            this.errorMessage = d.ErrorMessage;
            this.xmlData = d.XML_data;
            this.isLoading = false;
          } else {
            this.moduleStructure = d;
            this.defaultVals = d.defaultValues;
            this.saveToFinalDocConfig =
              this.moduleStructure.module.AdditionalInformationParsed.AllowSaveToDraft;
            this.ShowCommentsConfig =
              this.moduleStructure.module.AdditionalInformationParsed.ShowCommentSection;
            this.showCommunication =
              this.moduleStructure.module.AdditionalInformationParsed.ShowCommunication;
            this.initObject();
            const structureChanged$ =
              this.layoutService.moduleStructureChanged.subscribe(() => {
                ModuleStructure.refineTheRecordModel(
                  this.layoutService,
                  this.moduleStructure,
                  this.recordModel,
                  this.defaultVals,
                );

                this.afterInitObject();
              });
            this.subscriptions.push(structureChanged$);

            this.afterInitObject();
            this.initializeRecordModel();
          }
        });
      this.subscriptions.push(moduleStructure$);
    }

    this.handleParentChanged();
    if (
      this.Identity != null &&
      (this.Identity.Area === 2 || this.Identity.Area === 3) &&
      !this.fromDraft
    ) {
      this.activitiesList();
    }

    this.addressIsSetfromDoc = false;
    this.addressIsSetfromOAT = false;
    this.fieldShouldCopyIsSetfromDoc = false;
  }

  afterInitObject() {
    this.sections = this.getSectionsGrouped(
      this.moduleStructure.module.Sections,
    );
    this.buttonSections = this.getButtonSections(this.sections);
    this.normalSections = this.getNormalSections(
      this.moduleStructure.module.Sections,
    );
    this.drawerSections = this.getDrawerSections(
      this.moduleStructure.module.Sections,
    );

    const doc = new businessDoc.Documents(
      this.layoutService,
      this.message,
      this.modal,
      false,
    );

    doc.deliverScheduledIsOpened = [];
  }

  getSectionsGrouped(sections: Section[]): SectionGroup[] {
    const sectionsToReturn: SectionGroup[] = [];
    sections = sections.sort((a, b) => a.SortOrder - b.SortOrder);
    for (const section of sections) {
      /*if (linkedSections.Contains(section.Id)) {
        continue;
      }*/

      const tabGroup =
        section.TabGroup == null || section.TabGroup === ''
          ? 'NO_GROUP_' + section.Id
          : section.TabGroup;
      let sectionGroup = sectionsToReturn.find((pair) => pair.Key === tabGroup);

      if (sectionGroup === undefined) {
        sectionGroup = { Key: tabGroup, Value: [section] };
        sectionsToReturn.push({ Key: tabGroup, Value: [section] });
      } else {
        sectionGroup.Value.push(section);
      }

      sectionGroup.Value.sort((a, b) => a.SortOrder - b.SortOrder);
      /*var tabGroupToAdd = sectionsToReturn.First(pair => pair.Key == tabGroup);
      for (var linkedSection in sectionsLinks[section.Id])
      {
      tabGroupToAdd.Value.Add(linkedSection);
      }*/
    }

    return sectionsToReturn;
  }

  linkedObjectSubmitted(event) {}

  private initializeRecordModel() {
    if (this.recordId === undefined) {
      const queryParams$ = this.route.queryParams.subscribe((params) => {
        this.recordId = params.recordId;
      });
      this.subscriptions.push(queryParams$);
    }

    if (this.recordModel === undefined) {
      this.recordModel = {
        CreateMethodName: '',
        FormGUID: '',
        Categories: [],
        FromDraft: this.fromDraft,
        KeyName: '',
        KeyValue: '',
        SourceObjectId: '',
        LinesToDelete: '',
        ModuleApp: '',
        ModuleId: 0,
        ObjectCode: '',
        ObjectKey: '',
        ObjectTypeValue: '',
        RemoveMethodName: '',
        TableName: '',
        UpdateMethodName: '',
        copiedQuotEntries: [],
        AllowSaveToDraft: false,
      };

      if (
        this.sourceObject == null &&
        (this.recordId == null || this.recordId === '')
      ) {
        const defaultValues$ = this.layoutService
          .getDefaultValuesOnCreate(this.moduleStructure, this.moduleId)
          .subscribe((d: any) => {
            if (d.IsError === true) {
              this.isError = true;
              this.errorMessage = d.ErrorMessage;
              this.isLoading = false;
              this.xmlData = d.XML_data;

              return;
            } else {
              this.recordModel = JSON.parse(d.Values);
              this.recordModel.copiedQuotEntries = [];
              ModuleStructure.refineTheRecordModel(
                this.layoutService,
                this.moduleStructure,
                this.recordModel,
                this.defaultVals,
                true,
              );

              this.layoutService.objectLoadChanged.emit({
                recordModel: this.recordModel,
                moduleStructure: this.moduleStructure,
              });
              this.fillInputValues();
              this.recordModelChange.emit(this.recordModel);
              this.isLoading = false;

              this.showCopyFromButton =
                this.recordModel.EventType === EventType.Create &&
                LayoutService.isDocument(this.recordModel.ObjectKey) &&
                this.moduleStructure.module.AdditionalInformationParsed
                  .AllowCopyFrom;

              if (
                this.recordModel.EventType === EventType.Create &&
                (g.currentAppId.toString() === '9' ||
                  g.currentAppId.toString() === '10')
              ) {
                GlobalObject.FillDataOnExternalCreate(
                  this.recordModel,
                  this.moduleStructure,
                  this.layoutService,
                );
              }

              if (this.autoSubmit) {
                const internval = setInterval(() => {
                  if (this.submitting) return;

                  var modulesToCheck =
                    g.autoSubmitSaveDraftForModules.split(',');
                  if (
                    modulesToCheck.indexOf(
                      this.recordModel.ModuleId.toString(),
                    ) !== -1
                  ) {
                    this.submitObject(false, true);
                  } else {
                    this.submitObject();
                  }
                  clearInterval(internval);
                }, 100);
              }
            }
          });
        this.subscriptions.push(defaultValues$);
      } else if (
        this.sourceObject != null /*&&
        this.recordId !== undefined &&
        this.recordId !== ''*/
      ) {
        if (this.moduleActionType == null) {
          this.moduleActionType = 3;
        }
        if (Number(this.sourceObject) === 50026) {
          //this.customActionCode = 'PICKED_LINES';
          this.moduleActionType = 13;
        }
        const defaultValues$ = this.layoutService
          .getDefaultValuesOnCreate(
            this.moduleStructure,
            this.moduleId,
            this.moduleActionType,
            this.sourceObjectId.toString(),
            this.sourceObject,
            '',
            '',
            this.customActionCode,
            '',
          )
          .subscribe((d: any) => {
            if (d.IsError === true) {
              this.isError = true;
              this.errorMessage = d.ErrorMessage;
              this.isLoading = false;
              this.xmlData = d.XML_data;

              return;
            } else {
              console.log('Started:', new Date());
              this.recordModel = JSON.parse(d.Values);
              this.recordModel.SourceObjectId = this.sourceObjectId.toString();
              this.recordModel.copiedQuotEntries = [];

              var docsToCheck =
                g.checkPropertiesToIgnoreInCopyToForDocuments.split(',');

              if (
                this.moduleActionType.toString() === '3' &&
                docsToCheck.indexOf(this.recordModel.ObjectKey) !== -1
              ) {
                const headerCat = this.recordModel.Categories.find(
                  (cat) => cat.Id === 'Documents',
                );

                if (
                  headerCat != null &&
                  headerCat !== undefined &&
                  headerCat.Lines != null &&
                  headerCat.Lines !== undefined &&
                  headerCat.Lines.length !== 0
                ) {
                  var propsToCheck = g.propertiesToIgnoreInCopyTo.split(',');

                  headerCat.Lines[0].Properties =
                    headerCat.Lines[0].Properties.filter(
                      (x) => propsToCheck.indexOf(x.Name) === -1,
                    );
                }
              }

              ModuleStructure.refineTheRecordModel(
                this.layoutService,
                this.moduleStructure,
                this.recordModel,
                this.defaultVals,
                true,
              );

              if (
                this.moduleActionType.toString() === '3' ||
                this.moduleActionType.toString() === '2' ||
                this.moduleActionType.toString() === '16' ||
                this.moduleActionType.toString() === '17' ||
                this.moduleActionType.toString() === '-1'
              ) {
                for (const section of this.moduleStructure.module.Sections) {
                  let recordCategory = this.recordModel.Categories.find(
                    (category) => category.Id === section.XmlTagName,
                  );
                  if (recordCategory === undefined || recordCategory === null) {
                    continue;
                  }
                  for (const recordLine of recordCategory.Lines) {
                    recordLine.IsNew = true;
                  }
                }
              }

              this.layoutService.objectLoadChanged.emit({
                recordModel: this.recordModel,
                moduleStructure: this.moduleStructure,
              });
              this.fillInputValues();
              this.recordModelChange.emit(this.recordModel);
              this.isLoading = false;

              this.showCopyFromButton =
                this.recordModel.EventType === EventType.Create &&
                LayoutService.isDocument(this.recordModel.ObjectKey) &&
                this.moduleStructure.module.AdditionalInformationParsed
                  .AllowCopyFrom;

              if (this.autoSubmit) {
                const internval = setInterval(() => {
                  if (this.submitting) return;

                  var modulesToCheck =
                    g.autoSubmitSaveDraftForModules.split(',');
                  if (
                    modulesToCheck.indexOf(
                      this.recordModel.ModuleId.toString(),
                    ) !== -1
                  ) {
                    this.submitObject(false, true);
                  } else {
                    this.submitObject();
                  }

                  clearInterval(internval);
                }, 100);
              }

              GlobalObject.ObjectLoad(
                this.recordModel,
                this.moduleStructure,
                this.layoutService,
              );

              var docsToCheckInDuplicate =
                g.checkPropertiesToTriggerInDuplicateForDocuments.split(',');

              if (
                (this.moduleActionType.toString() === '16' ||
                  this.moduleActionType.toString() === '2') &&
                docsToCheckInDuplicate.indexOf(this.recordModel.ObjectKey) !==
                  -1
              ) {
                setTimeout(() => {
                  var propsToCheck =
                    g.propertiesToTriggerInDuplicate.split(',');

                  propsToCheck.forEach((p) => {
                    let catId = p.split('.')[0];
                    let propName = p.split('.')[1];
                    let recordCategory = this.recordModel.Categories.find(
                      (category) => category.Id === catId,
                    );

                    for (const recordLine of recordCategory.Lines) {
                      const prop = recordLine.Properties.find(
                        (a) => a.Name === propName,
                      );

                      this.layoutService.triggerFieldValueChanged({
                        recordModel: this.recordModel,
                        recordProperty: prop,
                        formId: '',
                        line: recordLine.Id,
                        sectionTagName: catId,
                        moduleStructure: this.moduleStructure,
                      });
                    }
                  });
                }, 2000);
              }

              var docsToCheckInCopyTo =
                g.checkPropertiesToTriggerInCopyToForDocuments.split(',');

              if (
                (this.moduleActionType.toString() === '3' ||
                  this.moduleActionType.toString() === '17') &&
                docsToCheckInCopyTo.indexOf(this.recordModel.ObjectKey) !== -1
              ) {
                setTimeout(() => {
                  var propsToCheck = g.propertiesToTriggerInCopyTo.split(',');

                  propsToCheck.forEach((p) => {
                    let catId = p.split('.')[0];
                    let propName = p.split('.')[1];
                    let recordCategory = this.recordModel.Categories.find(
                      (category) => category.Id === catId,
                    );

                    for (const recordLine of recordCategory.Lines) {
                      const prop = recordLine.Properties.find(
                        (a) => a.Name === propName,
                      );

                      this.layoutService.triggerFieldValueChanged({
                        recordModel: this.recordModel,
                        recordProperty: prop,
                        formId: '',
                        line: recordLine.Id,
                        sectionTagName: catId,
                        moduleStructure: this.moduleStructure,
                      });
                    }
                  });
                }, 2000);
              }

              if (
                !g.ignoreTriggerPricesInCopyTo &&
                this.moduleActionType.toString() === '3' &&
                LayoutService.isDocument(this.recordModel.ObjectKey)
              ) {
                setTimeout(() => {
                  var propsToCheck =
                    'Document_Lines.UnitPrice,Document_Lines.PriceAfterVAT'.split(
                      ',',
                    );

                  propsToCheck.forEach((p) => {
                    let catId = p.split('.')[0];
                    let propName = p.split('.')[1];
                    let recordCategory = this.recordModel.Categories.find(
                      (category) => category.Id === catId,
                    );

                    if (
                      recordCategory != null &&
                      recordCategory !== undefined
                    ) {
                      for (const recordLine of recordCategory.Lines) {
                        const prop = recordLine.Properties.find(
                          (a) => a.Name === propName,
                        );

                        if (prop != null && prop !== undefined) {
                          this.layoutService.triggerFieldValueChanged({
                            recordModel: this.recordModel,
                            recordProperty: prop,
                            formId: '',
                            line: recordLine.Id,
                            sectionTagName: catId,
                            moduleStructure: this.moduleStructure,
                            onload: true,
                          });
                        }
                      }
                    }
                  });
                }, 2000);

                setTimeout(() => {
                  var propsToCheck = 'Document_Lines.OnHand'.split(',');

                  propsToCheck.forEach((p) => {
                    let catId = p.split('.')[0];
                    let propName = p.split('.')[1];
                    let recordCategory = this.recordModel.Categories.find(
                      (category) => category.Id === catId,
                    );

                    if (
                      recordCategory != null &&
                      recordCategory !== undefined
                    ) {
                      for (const recordLine of recordCategory.Lines) {
                        const prop = recordLine.Properties.find(
                          (a) => a.Name === propName,
                        );

                        if (prop != null && prop !== undefined) {
                          this.layoutService.triggerFieldValueChanged({
                            recordModel: this.recordModel,
                            recordProperty: prop,
                            formId: '',
                            line: recordLine.Id,
                            sectionTagName: catId,
                            moduleStructure: this.moduleStructure,
                          });
                        }
                      }
                    }
                  });
                }, 4000);
              }

              if (
                this.moduleActionType.toString() === '17' &&
                LayoutService.isDocument(this.recordModel.ObjectKey)
              ) {
                setTimeout(() => {
                  var propsToCheck =
                    'Document_Lines.UnitPrice,Document_Lines.ShipDate'.split(
                      ',',
                    );

                  propsToCheck.forEach((p) => {
                    let catId = p.split('.')[0];
                    let propName = p.split('.')[1];
                    let recordCategory = this.recordModel.Categories.find(
                      (category) => category.Id === catId,
                    );

                    if (
                      recordCategory != null &&
                      recordCategory !== undefined
                    ) {
                      for (const recordLine of recordCategory.Lines) {
                        const prop = recordLine.Properties.find(
                          (a) => a.Name === propName,
                        );

                        if (prop != null && prop !== undefined) {
                          this.layoutService.triggerFieldValueChanged({
                            recordModel: this.recordModel,
                            recordProperty: prop,
                            formId: '',
                            line: recordLine.Id,
                            sectionTagName: catId,
                            moduleStructure: this.moduleStructure,
                          });
                        }
                      }
                    }
                  });

                  let billOfMaterials = new BillOfMaterials(
                    this.layoutService,
                    this.message,
                    this.billOfMaterialService,
                    false,
                  );

                  let recordCategory = this.recordModel.Categories.find(
                    (category) => category.Id === 'Document_Lines',
                  );

                  if (recordCategory != null && recordCategory !== undefined) {
                    for (const recordLine of recordCategory.Lines) {
                      const prop = recordLine.Properties.find(
                        (a) => a.Name === 'ItemCode',
                      );

                      if (prop != null && prop !== undefined) {
                        billOfMaterials.LoadBOMItems({
                          recordModel: this.recordModel,
                          recordProperty: prop,
                          formId: '',
                          line: recordLine.Id,
                          sectionTagName: 'Document_Lines',
                          moduleStructure: this.moduleStructure,
                        });
                      }
                    }
                  }
                }, 2000);
              }

              if (
                this.moduleActionType.toString() === '9' &&
                this.customActionCode === 'OFFLOAD_TO_GRPO'
              ) {
                setTimeout(() => {
                  let headerCat = this.recordModel.Categories.find(
                    (category) => category.Id === 'Documents',
                  );

                  const notMappedItems = headerCat.Lines[0].Properties.find(
                    (prop) => prop.Name === 'PO_NOT_MAPPED_ITEM',
                  )?.ValueAsObject;
                  const notMappedOffItems = headerCat.Lines[0].Properties.find(
                    (prop) => prop.Name === 'OFF_NOT_MAPPED_ITEM',
                  )?.ValueAsObject;

                  if (
                    notMappedOffItems == null ||
                    notMappedOffItems === undefined ||
                    notMappedOffItems === ''
                  ) {
                    return;
                  }
                  const drawerRef = this.drawerService.create<
                    OffloadMappingComponent,
                    {
                      notMappedItemsJson: string;
                      notMappedOffItemsJson: string;
                    },
                    string
                  >({
                    nzContent: OffloadMappingComponent,
                    nzWrapClassName: 'drawer-size-3x',
                    nzTitle: 'Item Mapping',
                    nzContentParams: {
                      notMappedItemsJson: notMappedItems,
                      notMappedOffItemsJson: notMappedOffItems,
                    },
                  });

                  drawerRef.afterClose.subscribe((result: string) => {
                    if (!result) {
                      return;
                    }

                    try {
                      const parsed = JSON.parse(result);
                      console.log(parsed);
                      let recordCategory = this.recordModel.Categories.find(
                        (category) => category.Id === 'Document_Lines',
                      );

                      if (
                        recordCategory != null &&
                        recordCategory !== undefined
                      ) {
                        for (const recordLine of recordCategory.Lines) {
                          const itemCodeProp = recordLine.Properties.find(
                            (a) => a.Name === 'ItemCode',
                          );

                          if (!itemCodeProp?.Value) {
                            continue;
                          }

                          const mapping = parsed.find(
                            (x) => x.offloadItem === itemCodeProp.Value,
                          );

                          if (!mapping) {
                            continue;
                          }

                          const mappedTypeProp = recordLine.Properties.find(
                            (a) => a.Name === 'U_MAPPED_TYPE',
                          );
                          const mappedItemProp = recordLine.Properties.find(
                            (a) => a.Name === 'U_MAPPED_ITEM',
                          );
                          const mappedPoProp = recordLine.Properties.find(
                            (a) => a.Name === 'U_MAPPED_PO',
                          );

                          if (mappedTypeProp) {
                            mappedTypeProp.ValueAsObject =
                              mappedTypeProp.Value = mapping.mappingType;
                          }

                          if (mappedItemProp) {
                            mappedItemProp.ValueAsObject =
                              mappedItemProp.Value = mapping.mappedItem;
                          }

                          if (mappedPoProp) {
                            mappedPoProp.ValueAsObject = mappedPoProp.Value =
                              mapping.poNumber;
                          }
                        }
                      }
                    } catch (error) {
                      console.error('Invalid drawer result JSON', error);
                    }
                  });
                }, 2000);
              }

              console.log('Finished:', new Date());
            }
          });
        this.subscriptions.push(defaultValues$);
      } else {
        this.loadRecordData();
      }
    } else {
      ModuleStructure.refineTheRecordModel(
        this.layoutService,
        this.moduleStructure,
        this.recordModel,
        this.defaultVals,
      );

      if (this.recordId !== undefined) {
        this.recordModel.KeyValue = this.recordId.toString();
      }

      this.recordModelChange.emit(this.recordModel);
      this.layoutService.objectLoadChanged.emit({
        recordModel: this.recordModel,
        moduleStructure: this.moduleStructure,
      });

      this.isLoading = false;
    }

    if (
      this.recordModel.FormGUID === '' ||
      this.recordModel.FormGUID === undefined
    ) {
      this.recordModel.FormGUID = parseInt(
        (Math.random() * 100000).toString(),
        10,
      ).toString();
    }

    if (this.moduleId === 10023 && !this.inDrawer) {
      const documentSection: Section =
        this.moduleStructure.module.Sections.find(
          (sec) => sec.XmlTagName === 'Documents',
        );

      const cardCode = documentSection.Fields.find(
        (prop) => prop.FieldName === 'CardCode',
      );
      if (cardCode != null)
        cardCode.AdditionalInformationParsed.Visible = false;
      const cardName = documentSection.Fields.find(
        (prop) => prop.FieldName === 'CardName',
      );
      if (cardName != null)
        cardName.AdditionalInformationParsed.Visible = false;
    }
  }

  loadRecordData() {
    console.log('this.isLoading ==> ' + this.isLoading);
    const edit = this.layoutService.getValuesOnEdit(
      this.moduleStructure,
      this.moduleId,
      encodeURIComponent(this.recordId).replace('+', '%2B'),
      this.fromDraft,
      this.fromLog,
      this.logInstance,
      this.linkedField,
    ) as Observable<any>;
    this.subscriptions.push(
      edit
        .pipe(
          tap((d: any) => {
            if (d.IsError === true) {
              this.isError = true;
              this.errorMessage = d.ErrorMessage;
              this.isLoading = false;
              this.xmlData = d.XML_data;
              return;
            }

            this.recordModel = JSON.parse(d.Values);
            this.recordModel.copiedQuotEntries = [];

            if (this.recordModel.FromDraft) {
              if (
                this.moduleStructure.module.Id !== this.recordModel.ModuleId &&
                (this.recordModel.ObjectKey === 'oInventoryTransferRequest' ||
                  this.recordModel.ObjectKey === 'oStockTransfer' ||
                  this.recordModel.ObjectKey === 'oPurchaseRequest' ||
                  this.recordModel.ObjectKey === 'oInventoryGenExit')
              ) {
                const moduleStructure$ = this.layoutService
                  .getModuleStructure(this.recordModel.ModuleId)
                  .subscribe((d: any) => {
                    if (d.IsError === true) {
                      this.isError = true;
                      this.errorMessage = d.ErrorMessage;
                      this.xmlData = d.XML_data;
                      this.isLoading = false;
                    } else {
                      this.moduleStructure = d;
                      this.defaultVals = d.defaultValues;
                      this.saveToFinalDocConfig =
                        this.moduleStructure.module.AdditionalInformationParsed.AllowSaveToDraft;
                      this.ShowCommentsConfig =
                        this.moduleStructure.module.AdditionalInformationParsed.ShowCommentSection;
                      this.showCommunication =
                        this.moduleStructure.module.AdditionalInformationParsed.ShowCommunication;
                      this.initObject();
                      const structureChanged$ =
                        this.layoutService.moduleStructureChanged.subscribe(
                          () => {
                            ModuleStructure.refineTheRecordModel(
                              this.layoutService,
                              this.moduleStructure,
                              this.recordModel,
                              this.defaultVals,
                            );

                            this.afterInitObject();
                          },
                        );
                      this.subscriptions.push(structureChanged$);

                      this.afterInitObject();
                      this.initializeRecordModel();
                      let xmlTagName = 'Documents';
                      if (
                        this.recordModel.ObjectKey ===
                          'oInventoryTransferRequest' ||
                        this.recordModel.ObjectKey === 'oStockTransfer'
                      ) {
                        xmlTagName = 'StockTransfer';
                      }
                      const headerCat = this.recordModel.Categories.find(
                        (cat) => cat.Id === xmlTagName,
                      );
                      if (
                        headerCat != null &&
                        headerCat !== undefined &&
                        headerCat.Lines != null &&
                        headerCat.Lines !== undefined &&
                        headerCat.Lines.length !== 0
                      ) {
                        const auth = headerCat.Lines[0].Properties.find(
                          (prop) => prop.Name === 'AuthStatus',
                        )?.ValueAsObject;
                        const status = headerCat.Lines[0].Properties.find(
                          (prop) => prop.Name === 'DocumentStatus',
                        )?.ValueAsObject;
                        this.showSaveTofinalButton =
                          this.showSaveTofinalButtonConfig &&
                          (auth === 'Y' || auth === '-' || auth == null) &&
                          (status === 'O' ||
                            status === 'bost_Open' ||
                            status == null);
                        this.showSubmitButton =
                          auth === '-' &&
                          (status === 'O' || status === 'bost_Open');
                        if (this.showSaveTofinalButton && auth !== '-') {
                          this.recordModel.EventType = EventType.View;
                          //this.showSubmitButton = true;
                        }
                        if (auth === 'N') {
                          this.showAddAgain = true;
                        }
                      }
                    }
                  });
                this.subscriptions.push(moduleStructure$);
              } else {
                const headerCat = this.recordModel.Categories.find(
                  (cat) => cat.Id === 'Documents',
                );
                if (
                  headerCat != null &&
                  headerCat !== undefined &&
                  headerCat.Lines != null &&
                  headerCat.Lines !== undefined &&
                  headerCat.Lines.length !== 0
                ) {
                  const auth = headerCat.Lines[0].Properties.find(
                    (prop) => prop.Name === 'AuthStatus',
                  )?.ValueAsObject;
                  const status = headerCat.Lines[0].Properties.find(
                    (prop) => prop.Name === 'DocumentStatus',
                  )?.ValueAsObject;
                  this.showSaveTofinalButton =
                    this.showSaveTofinalButtonConfig &&
                    (auth === 'Y' || auth === '-' || auth == null) &&
                    (status === 'O' ||
                      status === 'bost_Open' ||
                      status == null);
                  this.showSubmitButton =
                    auth === '-' && (status === 'O' || status === 'bost_Open');
                  if (this.showSaveTofinalButton && auth !== '-') {
                    //this.recordModel.EventType = EventType.View;
                    this.showSubmitButton = true;
                  }
                  if (auth === 'N') {
                    this.showAddAgain = true;
                  }
                }
              }
            }

            const parsed = g.parseCustomConfiguration(g.allowEditEvenWhenClose);
            const parsedSection = g.parseCustomConfiguration(
              g.allowAddLinesEvenWhenClose,
            );
            this.allowUpdateWnenClose = false;
            if (
              (parsed.hasOwnProperty(this.recordModel.ObjectKey) &&
                Array.isArray(parsed[this.recordModel.ObjectKey]) &&
                parsed[this.recordModel.ObjectKey].length > 0) ||
              (parsedSection.hasOwnProperty(this.recordModel.ObjectKey) &&
                Array.isArray(parsedSection[this.recordModel.ObjectKey]) &&
                parsedSection[this.recordModel.ObjectKey].length > 0)
            ) {
              this.allowUpdateWnenClose = true;
            }

            if (
              this.recordModel.EventType === EventType.View &&
              !this.isTokenized
            ) {
              this.actionType = 'View';
              if (this.allowUpdateWnenClose) {
                this.recordModel.EventType = EventType.Update;
              }
            } else if (
              this.recordModel.EventType === EventType.Create &&
              !this.isTokenized
            ) {
              this.actionType = 'Add';
            } else if (
              this.recordModel.EventType === EventType.Update &&
              !this.isTokenized
            ) {
              this.actionType = 'Edit';
            }
            this.isLoading = false;

            ModuleStructure.refineTheRecordModel(
              this.layoutService,
              this.moduleStructure,
              this.recordModel,
              this.defaultVals,
            );

            this.layoutService.objectLoadChanged.emit({
              recordModel: this.recordModel,
              moduleStructure: this.moduleStructure,
            });
            this.fillInputValues();
            this.recordModelChange.emit(this.recordModel);
            const documentCategory = this.recordModel.Categories.find(
              (x) => x.Id === 'Documents',
            );
            const ServiceCall = this.recordModel.Categories.find(
              (x) => x.Id === 'ServiceCalls',
            );
            this.documentHead =
              documentCategory === undefined
                ? ServiceCall?.Lines
                : documentCategory?.Lines;

            GlobalObject.ObjectLoad(
              this.recordModel,
              this.moduleStructure,
              this.layoutService,
            );
          }),
        )
        .subscribe(),
    );
  }

  fillInputValues() {
    if (this.inputValues === undefined && this.initValues === undefined) {
      return;
    }
    if (this.inputValues !== undefined) {
      const keys = Object.keys(this.inputValues);
      for (const key of keys) {
        const value = this.inputValues[key];
        const xmlTagName = key.split('.')[0];
        const propertyName = key.split('.')[1];

        for (const category of this.recordModel.Categories) {
          if (category.Id !== xmlTagName) {
            continue;
          }

          if (category.Lines.length === 0) {
            continue;
          }

          const recordLine = category.Lines[0];
          for (const property of recordLine.Properties) {
            if (property.Name !== propertyName) {
              continue;
            }

            const section = this.moduleStructure.module.Sections.find(
              (s) =>
                s.XmlTagName === xmlTagName &&
                s.Fields.find((f) => f.PropertyName === propertyName) !==
                  undefined,
            );
            const field = section.Fields.find(
              (f) => f.PropertyName === propertyName,
            );
            // property.ValueAsObject = value;
            LayoutService.setValue(
              property,
              value,
              this.layoutService,
              this.recordModel,
              0,
              section.XmlTagName,
              this.moduleStructure,
            );

            /*this.layoutService.triggerFieldValueChanged({
            recordProperty: property,
            formId: '',
            line: 0,
            recordModel: this.recordModel,
            sectionTagName: section.XmlTagName,
            moduleStructure: this.moduleStructure,
          });*/

            if (property.DataType === FieldDataType.Link) {
              const moduleHeader$ = this.layoutService
                .getModuleHeaderData(field.LinkedModule, value, '', false)
                .subscribe((d) => {
                  this.moduleStructure.module.Sections.forEach((s) => {
                    s.Fields.forEach((linkedField) => {
                      if (
                        linkedField.LinkedModule === field.LinkedModule &&
                        linkedField.LinkedModuleGroup ===
                          field.LinkedModuleGroup
                      ) {
                        const linkedValue = d[linkedField.LinkedField];
                        const linkedProperty = recordLine.Properties.find(
                          (p) => p.Name === linkedField.PropertyName,
                        );

                        // linkedProperty.ValueAsObject = linkedValue;

                        if (linkedValue !== null && linkedValue !== undefined) {
                          LayoutService.setValue(
                            linkedProperty,
                            linkedValue,
                            this.layoutService,
                            this.recordModel,
                            0,
                            s.XmlTagName,
                            this.moduleStructure,
                          );
                        }

                        /*this.layoutService.triggerFieldValueChanged({
                        recordProperty: linkedProperty,
                        formId: '',
                        line: 0,
                        recordModel: this.recordModel,
                        sectionTagName: section.XmlTagName,
                        moduleStructure: this.moduleStructure,
                      });*/
                      }
                    });
                  });
                });
              this.subscriptions.push(moduleHeader$);
            }
          }
        }
      }
    }

    if (this.initValues == null) {
      return;
    }

    console.log('this.initValues', this.initValues);
    for (const changedProperty of this.initValues) {
      const category = this.recordModel.Categories.find(
        (c) => c.Id === changedProperty.CategoryId,
      );

      const line = category.Lines.find((l) => l.Id === changedProperty.LineId);
      if (changedProperty.ActionType === ChangedValueModelActionType.SetValue) {
        const property = line.Properties.find(
          (p) => p.Name === changedProperty.PropertyName,
        );

        LayoutService.setValue(
          property,
          changedProperty.Value,
          this.layoutService,
          this.recordModel,
          changedProperty.LineId,
          changedProperty.CategoryId,
          this.moduleStructure,
        );
      } else if (
        changedProperty.ActionType === ChangedValueModelActionType.AddLine
      ) {
        const lineSection = this.moduleStructure.module.Sections.find(
          (x) => x.XmlTagName === changedProperty.CategoryId,
        );

        RecordModel.addLineToTable(
          this.recordModel,
          lineSection,
          category,
          this.moduleStructure.defaultValues,
          category.Lines,
          this.layoutService,
          this.moduleStructure,
          null,
          changedProperty.Value,
        );
      } else if (
        changedProperty.ActionType === ChangedValueModelActionType.DeleteLine
      ) {
      }
      const section = this.moduleStructure.module.Sections.find(
        (x) => x.XmlTagName === changedProperty.CategoryId,
      );
      const recordLine = category.Lines.find(
        (x) => x.Id === changedProperty.LineId,
      );
      RecordModel.refineTheRecordModelLine(
        this.layoutService,
        section,
        recordLine,
        this.moduleStructure.defaultValues,
      );

      /*this.layoutService.lineAdded.emit({
        recordLine,
        moduleStructure: this.moduleStructure,
        section: section,
        recordModel: this.recordModel,
      });*/
    }
  }

  openSection(sectionId: number) {
    const section = this.moduleStructure.module.Sections.find(
      (s: Section) => s.Id === sectionId,
    );
    if (section !== undefined) {
      section.DrawerOpen = true;
      return;
    }
  }
  updateSections(sections: Section[]) {
    const documents = this.recordModel.Categories?.find(
      (x) => x.Id == 'Documents',
    );
    const documentLines = this.recordModel.Categories?.find(
      (x) => x.Id == 'DocumentLines',
    );
    if (
      this.recordModel != null &&
      this.recordModel.Categories.length > 0 &&
      document != null &&
      documentLines != null
    ) {
      // dDocument_Service
      const isItemsDocument =
        this.recordModel.Categories.find(
          (x) => x.Id == 'Documents',
        ).Lines[0].Properties.find((x) => x.Name == 'DocType').ValueAsObject ==
          'I' ||
        this.recordModel.Categories.find(
          (x) => x.Id == 'Documents',
        ).Lines[0].Properties.find((x) => x.Name == 'DocType').ValueAsObject ==
          'dDocument_Items';
      if (isItemsDocument != null && !isItemsDocument) {
        sections.find(
          (x) =>
            x.XmlTagName === 'Document_Lines' &&
            x.TitleForList.toLowerCase().includes('items'),
        ).AdditionalInformationParsed.Hidden = true;
        sections.find(
          (x) =>
            x.XmlTagName === 'Document_Lines' &&
            x.TitleForList.toLowerCase().includes('services'),
        ).AdditionalInformationParsed.Hidden = false;
        if (!this.sectionsUpdated) {
          this.sectionsUpdated = true;
          this.layoutService.moduleStructureChanged.emit();
        }
      } else {
        sections.find(
          (x) =>
            x.XmlTagName === 'Document_Lines' &&
            x.TitleForList.toLowerCase().includes('items'),
        ).AdditionalInformationParsed.Hidden = false;
        sections.find(
          (x) =>
            x.XmlTagName === 'Document_Lines' &&
            x.TitleForList.toLowerCase().includes('services'),
        ).AdditionalInformationParsed.Hidden = true;

        if (!this.sectionsUpdated) {
          this.sectionsUpdated = true;
          this.layoutService.moduleStructureChanged.emit();
        }
      }
    }

    return sections;
  }
  getNormalSections(sections: Section[]): SectionGroup[] {
    sections = sections.sort((a, b) => a.SortOrder - b.SortOrder);
    if (this.recordModel == null) {
      let counter = 0;
      const inter = setInterval(() => {
        const document = this.recordModel?.Categories?.find(
          (x) => x.Id == 'Documents',
        );
        if (this.recordModel != null && document != null) {
          sections = this.updateSections(sections);
          clearInterval(inter);
        }
        counter++;
        if (counter > 3) {
          clearInterval(inter);
        }
      }, 2000);
    } else {
      sections = this.updateSections(sections);
    }
    const result: SectionGroup[] = [];
    for (const section of sections) {
      if (
        !section.AdditionalInformationParsed.Hidden &&
        (section.TabGroup == null || !section.TabGroup.startsWith('BTN_')) &&
        !section.AdditionalInformationParsed.IsInDrawer
      ) {
        if (
          section.XmlTagName !== 'SpecialLines' &&
          section.Type !== 8 &&
          (section.Type === 3 ||
            section.Fields.length > 0 ||
            section.Type === 10) &&
          (section.Type !== 3 ||
            this.actionType !== 'Add' ||
            section.AdditionalInformationParsed.ShowSectionInAddMode)
        ) {
          if (section.TabGroup == null || section.TabGroup === '') {
            result.push({ Key: '', Value: [section] });
          } else {
            const sectionGroup = result.find((s) => s.Key === section.TabGroup);
            if (sectionGroup === undefined) {
              result.push({ Key: section.TabGroup, Value: [section] });
            } else {
              sectionGroup.Value.push(section);
            }
          }
        }
      }
    }

    return result;
  }

  getDrawerSections(sections: any[]): any[] {
    const result: any[] = [];
    for (const section of sections) {
      if (section.AdditionalInformationParsed.IsInDrawer) {
        result.push(section);
      }
    }

    return result.sort((a, b) => a.SortOrder - b.SortOrder);
  }

  getButtonSections(sections: SectionGroup[]): SectionGroup[] {
    const result: SectionGroup[] = [];
    for (const section of sections) {
      if (section.Key.startsWith('BTN_')) {
        let toAdd = false;
        section.Value = section.Value.sort((a, b) => a.SortOrder - b.SortOrder);
        for (const value of section.Value) {
          if (
            !value.AdditionalInformationParsed.Hidden &&
            (value.Type !== 3 ||
              this.actionType !== 'Add' ||
              value.AdditionalInformationParsed.ShowSectionInAddMode)
          ) {
            toAdd = true;
            break;
          }
        }
        if (toAdd) {
          result.push(section);
        }
      }
    }

    return result;
  }

  open(sectionGroup: any): void {
    sectionGroup.visible = true;
  }

  close(sectionGroup: any): void {
    sectionGroup.visible = false;
    console.log('sectionGroup', sectionGroup);
    console.log(this.recordModel);
  }

  takeOver() {
    this.modal.confirm({
      nzTitle: this.layoutService.translate(
        'Are you sure you want to take over this transaction?',
      ),
      nzOkText: this.layoutService.translate('Yes'),
      nzCancelText: this.layoutService.translate('No'),
      nzOnOk: () => {
        const freeRecord$ = this.layoutService
          .freeRecord(
            this.moduleActionType === undefined
              ? this.moduleId
              : this.sourceObject,
            this.moduleActionType === undefined
              ? this.recordId
              : this.sourceObjectId,
          )
          .subscribe((x: any[]) => {
            this.isError = false;
            this.isLoading = true;
            // this.moduleStructure = undefined;
            this.recordModel = undefined;
            if (this.moduleActionType === undefined) {
              this.loadRecordData();
            } else {
              this.recordId = this.sourceObjectId;
              this.initializeRecordModel();
            }
          });
        this.subscriptions.push(freeRecord$);
      },
    });
  }

  footerButtonClicked(button: AdditionalButton) {
    this.layoutService.footerButtonClicked.emit(button);
  }
  removeObject() {
    this.modal.confirm({
      nzTitle: this.layoutService.translate(
        'Are you sure you want to remove this object?',
      ),
      nzOkText: this.layoutService.translate('Yes'),
      nzCancelText: this.layoutService.translate('No'),
      nzOnOk: () => {
        this.removing = true;
        const removeObj$ = this.layoutService
          .removeObject(this.recordModel, this.moduleStructure)
          .subscribe((d: any) => {
            this.removing = false;
            if (d.Has_Error) {
              this.message.create('error', d.Error_Message);
            } else {
              this.message.create(
                this.layoutService.translate('success'),
                this.layoutService.translate(`Object removed successfully`) +
                  ` , No. #${d.Resault_Value}`,
              );

              this.backButtonClicked.emit();
            }
          });
        this.subscriptions.push(removeObj$);
      },
    });
  }

  saveDraftDocumentToFinal() {
    this.submitting = true;
    this.submittingModel = true;
    const saveDraft$ = this.layoutService
      .saveDraftDocumentToFinal(
        this.recordModel,
        Number(this.recordModel.KeyValue),
      )
      .subscribe((d: any) => {
        this.submitting = false;
        this.submittingModel = false;
        console.log(d);
        if (d.Has_Error) {
          this.notificationService.error(
            this.layoutService.translate('Error'),
            d.Error_Message,
            { nzDuration: 5000 },
          );
        } else {
          let keyToDisplay =
            this.recordModel.ObjectKey === 'oServiceCalls' ||
            d.DocumentNumber == null ||
            d.DocumentNumber === undefined ||
            d.DocumentNumber === 0
              ? d.Resault_Value
              : d.DocumentNumber;
          this.notificationService.success(
            this.layoutService.translate('Success'),
            this.layoutService.translate(`Operation completed successfully`) +
              ` , No. #${keyToDisplay}`,
          );
          //console.log(this.recordModel);
          //console.log(d.Resault_Value);
          this.moduleId = this.recordModel.ModuleId;
          this.recordModel.FromDraft = false;
          this.fromDraft = false;
          if (this.inDrawer) {
            this.backButtonClicked.emit();
          } else {
            const url = this.router.url;
            this.fromDraft = false;
            this.recordModel.FromDraft = false;
            /*setTimeout(() => {
              this.router.navigate([
                `/apps/${
                  url.indexOf('inventory') > -1 ? 'inventory' : 'crm'
                }/module-list/${this.recordModel.ModuleId}/0`,
                {
                  selectedId: d.Resault_Value,
                  fromDraft: false,
                },
              ]);
            }, 1000);*/

            setTimeout(() => {
              this.fromDraft = false;
              this.recordModel.FromDraft = false;
              this.router.navigate([
                '/apps',
                url.includes('inventory') ? 'inventory' : 'crm',
                'module-list',
                this.recordModel.ModuleId,
                0,
                {
                  selectedId: d.Resault_Value,
                  fromDraft: false,
                },
              ]);
            }, 2000);
          }
        }
      });
    this.subscriptions.push(saveDraft$);
  }

  addRejectedDocument() {
    this.recordModel.FromDraft = false;
    this.recordModel.KeyValue = '';
    this.recordModel.EventType = 0;
    this.submitObject();
  }

  saveAsDraft() {
    this.submitObject(false, true);
  }

  addLineToTable(data: any, objectId: string, tableName: string) {
    if (data.Rate == 0 || data.Rate == '0') {
      data.Rate = 1;
    }
    console.log('addLineToTable', data);

    const currentObject = this.recordModel.ObjectKey;
    if (currentObject === 'BlanketAgreement') {
      let recordCategory: RecordCategory = null;
      const DocCurr = this.recordModel.Categories.find(
        (x) => x.Id == 'BlanketAgreement',
      )?.Lines[0].Properties.find((x) => x.Name == 'BPCurrency')?.ValueAsObject;

      const NumAtCardProp = this.recordModel.Categories.find(
        (x) => x.Id == 'BlanketAgreement',
      )?.Lines[0].Properties.find((x) => x.Name == 'NumAtCard');

      const DescriptionProp = this.recordModel.Categories.find(
        (x) => x.Id == 'BlanketAgreement',
      )?.Lines[0].Properties.find((x) => x.Name == 'Description');

      if (
        DescriptionProp != null &&
        (DescriptionProp.ValueAsObject == null ||
          DescriptionProp.ValueAsObject === undefined ||
          DescriptionProp.ValueAsObject === '')
      ) {
        //DescriptionProp.ValueAsObject = data.QuotName;
        //DescriptionProp.Value = data.QuotName;
        DescriptionProp.ValueAsObject = data.OpprName;
        DescriptionProp.Value = data.OpprName;
      }

      if (
        g.copyNumAtCardWhenCopyFrom &&
        NumAtCardProp != null &&
        data.NumAtCard != null &&
        data.NumAtCard != undefined
      ) {
        NumAtCardProp.ValueAsObject = data.NumAtCard;
        NumAtCardProp.Value = data.NumAtCard;
      }

      if (
        g.fieldsTobeCopiedWhenCopyFrom !== '' &&
        !this.fieldShouldCopyIsSetfromDoc
      ) {
        this.fieldShouldCopyIsSetfromDoc = true;
        let listOfFields = g.fieldsTobeCopiedWhenCopyFrom.split(',');
        listOfFields.forEach((fieldName) => {
          const field = this.recordModel.Categories.find(
            (x) => x.Id == 'BlanketAgreement',
          )?.Lines[0].Properties.find((x) => x.FieldName == fieldName);

          if (
            field != null &&
            data[fieldName] != null &&
            data[fieldName] != undefined
          ) {
            if (
              field.DataType === FieldDataType.Select &&
              (field.Options == null ||
                field.Options === undefined ||
                field.Options.length === 0)
            ) {
              const fieldStructure = this.moduleStructure.module.Sections.find(
                (x) => x.XmlTagName == 'Documents',
              )?.Fields.find(
                (p) => p.PropertyName === field.Name && p.Id === field.FieldId,
              );

              RecordModel.getOptions(
                fieldStructure,
                this.recordModel,
                field,
                recordCategory.Id,
                recordLine.Id,
                recordCategory,
                this.layoutService,
                this.moduleStructure,
              );
            }

            field.ValueAsObject = data[fieldName];
            field.Value = data[fieldName];
          }
        });
      }

      const section = this.moduleStructure.module.Sections.find(
        (sec) =>
          sec.XmlTagName ===
          'BlanketAgreements_ItemsLines|BlanketAgreements_ItemsLine',
      );
      this.recordModel.Categories.forEach((category) => {
        if (category.Id === section.XmlTagName) {
          recordCategory = category;
          return;
        }
      });

      if (recordCategory == null) {
        recordCategory = {
          Id: section.XmlTagName,
          Lines: [],
          DeletedLines: [],
        };
        this.recordModel.Categories.push(recordCategory);
      }

      let recordLine: RecordLine = null;

      for (let i = 0; i < recordCategory.Lines.length; i++) {
        const properties = recordCategory.Lines[i].Properties;
        const itemProp = properties.find((p) => p.Name === 'ItemNo');
        if (
          itemProp != null &&
          itemProp !== undefined &&
          data['ItemCode'] === itemProp.ValueAsObject
        ) {
          recordLine = recordCategory.Lines[i];
          break;
        }
      }

      if (recordLine === null) {
        if (recordCategory.Lines.length !== 0 && this.maxLineNum === 0) {
          this.maxLineNum =
            Math.max.apply(
              Math,
              recordCategory.Lines.map((o) => {
                if (
                  o.Properties.find(
                    (prop) => prop.Name === 'AgreementRowNumber',
                  ) === undefined
                ) {
                  return recordCategory.Lines.length;
                } else {
                  return o.Properties.find(
                    (prop) => prop.Name === 'AgreementRowNumber',
                  ).ValueAsObject;
                }
              }),
            ) + 1;
        } else {
          this.maxLineNum++;
        }
      }

      if (recordLine === null) {
        recordLine = {
          Id: recordCategory.Lines.length,
          MaxIndex: this.maxLineNum,
          Properties: [],
        };

        RecordModel.refineTheRecordModelLine(
          this.layoutService,
          section,
          recordLine,
          this.defaultVals,
        );

        this.layoutService.lineAdded.emit({
          recordLine,
          moduleStructure: this.moduleStructure,
          section: section,
          recordModel: this.recordModel,
        });
        recordLine.IsNew = true;
      } else {
        recordLine.IsNew = false;
      }

      console.log(recordLine);

      if (recordLine.IsNew) {
        for (const property of recordLine.Properties) {
          //#region handling some errors in service type docs
          if (property.Visible == null) {
            property.Visible = true;
          }
          if (property.ReadOnly == null) {
            property.ReadOnly = false;
          }
          if (property.Required == null) {
            property.Required = false;
          }
          if (property.ValueAsObject == null) {
            property.ValueAsObject = '';
          }
          //#endregion

          const field = section.Fields.find(
            (p) => p.PropertyName === property.Name,
          );
          if (field.ParentProperties != null && field.ParentProperties !== '') {
            let queryIdToExecute = field.SQLStatementParentChanged;
            if (queryIdToExecute == null || queryIdToExecute === 0) {
              queryIdToExecute = field.SQLStatementId;
            }

            if (queryIdToExecute != null && queryIdToExecute !== 0) {
            }
          }
        }

        recordCategory.Lines = [...recordCategory.Lines, recordLine];
        recordCategory.MaxIndex = this.maxLineNum;

        for (const property of recordLine.Properties) {
          if (g.userIdentity.Area == 3) {
            // property.Disabled = true;
            property.ReadOnly = true;
          }

          let valueProperty = !data.hasOwnProperty(property.Name)
            ? !data.hasOwnProperty(property.FieldName)
              ? null
              : data[property.FieldName]
            : data[property.Name];

          if (
            valueProperty === null &&
            property.Name !== 'AgreementRowNumber' &&
            property.Name !== 'ItemDescription' &&
            property.Name !== 'TaxValue' &&
            property.Name !== 'UnitPrice' &&
            property.Name !== 'BASE_LineTotal'
          ) {
            property.Value = '';
            property.ValueAsObject = '';
          } else if (
            [
              'LineNum',
              'BaseEntry',
              'BaseLine',
              'BaseType',
              'AgreementRowNumber',
            ].indexOf(property.Name) === -1
          ) {
            if (property.Name === 'PriceCurrency') {
              const documentSection = this.recordModel.Categories.find(
                (x) => x.Id === 'BlanketAgreement',
              );
              const currency = documentSection.Lines[0].Properties.find(
                (x) => x.Name === 'BPCurrency',
              );
              if (
                valueProperty.toString() != null &&
                valueProperty.toString() !== undefined &&
                valueProperty.toString() !== ''
              ) {
                currency.Value = valueProperty.toString();
                currency.ValueAsObject = valueProperty;
              }
            }

            if (property.DataType === FieldDataType.Select) {
              const field = section.Fields.find(
                (p) =>
                  p.PropertyName === property.Name && p.Id === property.FieldId,
              );

              RecordModel.getOptions(
                field,
                this.recordModel,
                property,
                recordCategory.Id,
                recordLine.Id,
                recordCategory,
                this.layoutService,
                this.moduleStructure,
              );
              property.Value = valueProperty.toString();
              property.ValueAsObject = valueProperty.toString();
            } else {
              if (property.Name == 'TaxValue') {
                console.log('Tax Value');
                if (this.isForeignCurr) {
                  if (Number(data.VatAppldFC) === 0) {
                    property.ValueAsObject = Number(data.VatSumFrgn);
                  } else {
                    property.ValueAsObject =
                      Number(data.VatSumFrgn) - Number(data.VatAppldFC);
                  }
                } else {
                  if (Number(data.VatAppld) === 0) {
                    property.ValueAsObject = Number(data.VatSum);
                  } else {
                    property.ValueAsObject =
                      Number(data.VatSum) - Number(data.VatAppld);
                  }
                }
                property.Value = property.ValueAsObject.toString();
              } else if (property.Name == 'TaxCode') {
                console.log('Tax Code');
                property.ValueAsObject = data.TaxCode;
                property.Value = property.ValueAsObject.toString();
              } else if (property.Name == 'UnitPrice') {
                property.ValueAsObject = data.PriceBefDi;
                property.Value = property.ValueAsObject.toString();
              } else {
                property.Value = valueProperty?.toString();
                property.ValueAsObject = valueProperty;
              }
            }
          }
        }

        for (const property1 of recordLine.Properties) {
          const field = section.Fields.find(
            (p) => p.PropertyName === property1.Name,
          );

          if (field.AdditionalInformationParsed.EditableInList) {
            this.layoutService.getFieldValueOnParentChange(
              this.recordModel,
              recordCategory,
              recordLine,
              property1,
              field.SQLStatementParentChanged,
              field,
              this.moduleStructure,
              true,
            );
          }
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'PlannedQuantity') !=
          null
        ) {
          recordLine.Properties.find(
            (x) => x.Name === 'PlannedQuantity',
          ).Value = data.OpenQty;
          recordLine.Properties.find(
            (x) => x.Name === 'PlannedQuantity',
          ).ValueAsObject = data.OpenQty;
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'U_ITM_BASE_IDS') != null
        ) {
          const baseIds = recordLine.Properties.find(
            (x) => x.Name === 'U_ITM_BASE_IDS',
          ).Value;
          if (baseIds != null && baseIds !== undefined && baseIds !== '') {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).Value = baseIds + ';' + data.DocEntry;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).ValueAsObject = baseIds + ';' + data.DocEntry;
          } else {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).Value = data.DocEntry;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).ValueAsObject = data.DocEntry;
          }
          if (
            this.recordModel.copiedQuotEntries.findIndex(
              (DocEntry) => DocEntry === data.DocEntry.toString(),
            ) === -1
          ) {
            this.recordModel.copiedQuotEntries.push(data.DocEntry.toString());
          }
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'U_ITM_BASE_LINES') !=
          null
        ) {
          const baselines = recordLine.Properties.find(
            (x) => x.Name === 'U_ITM_BASE_LINES',
          ).Value;
          if (
            baselines != null &&
            baselines !== undefined &&
            baselines !== ''
          ) {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).Value = baselines + ';' + data.LineNum;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).ValueAsObject = baselines + ';' + data.LineNum;
          } else {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).Value = data.LineNum;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).ValueAsObject = data.LineNum;
          }
        }
        // UDFs
      } else {
        if (
          recordLine.Properties.find((x) => x.Name === 'PlannedQuantity') !=
          null
        ) {
          recordLine.Properties.find(
            (x) => x.Name === 'PlannedQuantity',
          ).Value += data.OpenQty;
          recordLine.Properties.find(
            (x) => x.Name === 'PlannedQuantity',
          ).ValueAsObject += data.OpenQty;
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'U_ITM_BASE_IDS') != null
        ) {
          const baseIds = recordLine.Properties.find(
            (x) => x.Name === 'U_ITM_BASE_IDS',
          ).Value;
          if (baseIds != null && baseIds !== undefined && baseIds !== '') {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).Value = baseIds + ';' + data.DocEntry;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).ValueAsObject = baseIds + ';' + data.DocEntry;
          } else {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).Value = data.DocEntry;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_IDS',
            ).ValueAsObject = data.DocEntry;
          }
        }

        if (
          recordLine.Properties.find((x) => x.Name === 'U_ITM_BASE_LINES') !=
          null
        ) {
          const baselines = recordLine.Properties.find(
            (x) => x.Name === 'U_ITM_BASE_LINES',
          ).Value;
          if (
            baselines != null &&
            baselines !== undefined &&
            baselines !== ''
          ) {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).Value = baselines + ';' + data.LineNum;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).ValueAsObject = baselines + ';' + data.LineNum;
          } else {
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).Value = data.LineNum;
            recordLine.Properties.find(
              (x) => x.Name === 'U_ITM_BASE_LINES',
            ).ValueAsObject = data.LineNum;
          }
        }
        //UDFs
      }

      this.layoutService.linesChanged.emit(recordCategory);
    } else if (tableName === 'OAT') {
      let recordCategory: RecordCategory = null;

      const DocCurr = this.recordModel.Categories.find(
        (x) => x.Id == 'Documents',
      )?.Lines[0].Properties.find(
        (x) => x.Name == 'DocCurrency',
      )?.ValueAsObject;

      if (data.Currency != g.companyConfiguration.LocalCurrency) {
        this.isForeignCurr = true;
      }

      const DocDueDateProp = this.recordModel.Categories.find(
        (x) => x.Id == 'Documents',
      )?.Lines[0].Properties.find((x) => x.Name == 'DocDueDate');

      const TransportationCodeProp = this.recordModel.Categories.find(
        (x) => x.Id == 'Documents',
      )?.Lines[0].Properties.find((x) => x.Name == 'TransportationCode');

      const NumAtCardProp = this.recordModel.Categories.find(
        (x) => x.Id == 'Documents',
      )?.Lines[0].Properties.find((x) => x.Name == 'NumAtCard');

      if (
        g.copyNumAtCardWhenCopyFrom &&
        NumAtCardProp != null &&
        data.NumAtCard != null &&
        data.NumAtCard != undefined
      ) {
        NumAtCardProp.ValueAsObject = data.NumAtCard;
        NumAtCardProp.Value = data.NumAtCard;
      }

      if (
        g.fieldsTobeCopiedWhenCopyFrom !== '' &&
        !this.fieldShouldCopyIsSetfromDoc
      ) {
        this.fieldShouldCopyIsSetfromDoc = true;
        let listOfFields = g.fieldsTobeCopiedWhenCopyFrom.split(',');
        listOfFields.forEach((fieldName) => {
          const field = this.recordModel.Categories.find(
            (x) => x.Id == 'Documents',
          )?.Lines[0].Properties.find((x) => x.FieldName == fieldName);

          if (
            field != null &&
            data[fieldName] != null &&
            data[fieldName] != undefined
          ) {
            if (
              field.DataType === FieldDataType.Select &&
              (field.Options == null ||
                field.Options === undefined ||
                field.Options.length === 0)
            ) {
              const fieldStructure = this.moduleStructure.module.Sections.find(
                (x) => x.XmlTagName == 'Documents',
              )?.Fields.find(
                (p) => p.PropertyName === field.Name && p.Id === field.FieldId,
              );

              RecordModel.getOptions(
                fieldStructure,
                this.recordModel,
                field,
                recordCategory.Id,
                recordLine.Id,
                recordCategory,
                this.layoutService,
                this.moduleStructure,
              );
            }

            field.ValueAsObject = data[fieldName];
            field.Value = data[fieldName];
          }
        });
      }

      if (
        g.oAT_FieldsTobeCopiedWhenCopyFromAddress !== '' &&
        !this.addressIsSetfromOAT
      ) {
        this.addressIsSetfromOAT = true;
        const addressCat = this.recordModel.Categories.find(
          (x) => x.Id == 'AddressExtension',
        );

        let listOfFields = g.oAT_FieldsTobeCopiedWhenCopyFromAddress.split(',');
        listOfFields.forEach((fieldName) => {
          const field = addressCat.Lines[0].Properties.find(
            (x) => x.FieldName == fieldName,
          );

          if (
            field != null /*&&
            data[fieldName] != null &&
            data[fieldName] != undefined*/
          ) {
            if (
              field.DataType === FieldDataType.Select &&
              (field.Options == null ||
                field.Options === undefined ||
                field.Options.length === 0)
            ) {
              const fieldStructure = this.moduleStructure.module.Sections.find(
                (x) => x.XmlTagName == 'AddressExtension',
              )?.Fields.find(
                (p) => p.PropertyName === field.Name && p.Id === field.FieldId,
              );

              RecordModel.getOptions(
                fieldStructure,
                this.recordModel,
                field,
                addressCat.Id,
                0,
                addressCat,
                this.layoutService,
                this.moduleStructure,
              );
            }

            field.ValueAsObject = data[fieldName];
            field.Value = data[fieldName];
          }
        });
      }

      const section = this.moduleStructure.module.Sections.find(
        (sec) => sec.XmlTagName === 'Document_Lines',
      );
      this.recordModel.Categories.forEach((category) => {
        if (category.Id === section.XmlTagName) {
          recordCategory = category;
          return;
        }
      });

      if (recordCategory == null) {
        recordCategory = {
          Id: section.XmlTagName,
          Lines: [],
          DeletedLines: [],
        };
        this.recordModel.Categories.push(recordCategory);
      }
      if (recordCategory.Lines.length !== 0 && this.maxLineNum === 0) {
        this.maxLineNum =
          Math.max.apply(
            Math,
            recordCategory.Lines.map(
              (o) =>
                o.Properties.find((prop) => prop.Name === 'LineNum')
                  .ValueAsObject,
            ),
          ) + 1;
      } else {
        this.maxLineNum++;
      }

      let recordLine: RecordLine = null;
      recordLine = {
        Id: recordCategory.Lines.length,
        MaxIndex: this.maxLineNum,
        Properties: [],
      };

      console.log(recordLine);

      RecordModel.refineTheRecordModelLine(
        this.layoutService,
        section,
        recordLine,
        this.defaultVals,
      );

      this.layoutService.lineAdded.emit({
        recordLine,
        moduleStructure: this.moduleStructure,
        section: section,
        recordModel: this.recordModel,
      });

      recordLine.IsNew = true;

      for (const property of recordLine.Properties) {
        if (property.Visible == null) {
          property.Visible = true;
        }
        if (property.ReadOnly == null) {
          property.ReadOnly = false;
        }
        if (property.Required == null) {
          property.Required = false;
        }
        if (property.ValueAsObject == null) {
          property.ValueAsObject = '';
        }

        const field = section.Fields.find(
          (p) => p.PropertyName === property.Name,
        );
        if (field.ParentProperties != null && field.ParentProperties !== '') {
          let queryIdToExecute = field.SQLStatementParentChanged;
          if (queryIdToExecute == null || queryIdToExecute === 0) {
            queryIdToExecute = field.SQLStatementId;
          }

          if (queryIdToExecute != null && queryIdToExecute !== 0) {
          }
        }
      }

      recordLine.Properties.find(
        (p) => p.Name === 'AgreementNo',
      ).ValueAsObject = data.AgrNo;

      recordLine.Properties.find(
        (p) => p.Name === 'AgreementRowNumber',
      ).ValueAsObject = data.AgrLineNum;

      if (recordLine.Properties.find((p) => p.Name === 'TreeType') != null) {
        recordLine.Properties.find((p) => p.Name === 'TreeType').ValueAsObject =
          data.TreeType;
      }

      recordCategory.Lines = [...recordCategory.Lines, recordLine];
      recordCategory.MaxIndex = this.maxLineNum;

      const doc = new businessDoc.Documents(
        this.layoutService,
        this.message,
        this.modal,
        false,
      );

      if (
        recordLine.Properties.find(
          (x) => x.Name === 'U_ITM_BWEB_PARENT_ITEM',
        ) != null
      ) {
        recordLine.Properties.find(
          (x) => x.Name === 'U_ITM_BWEB_PARENT_ITEM',
        ).Value = '';
        recordLine.Properties.find(
          (x) => x.Name === 'U_ITM_BWEB_PARENT_ITEM',
        ).ValueAsObject = '';
      }

      if (recordLine.Properties.find((x) => x.Name === 'ItemCode') != null) {
        recordLine.Properties.find((x) => x.Name === 'ItemCode').Value =
          data.ItemCode;
        recordLine.Properties.find((x) => x.Name === 'ItemCode').ValueAsObject =
          data.ItemCode;
      }

      if (
        recordLine.Properties.find((x) => x.Name === 'ItemDescription') != null
      ) {
        recordLine.Properties.find((x) => x.Name === 'ItemDescription').Value =
          data.Dscription;
        recordLine.Properties.find(
          (x) => x.Name === 'ItemDescription',
        ).ValueAsObject = data.Dscription;
      }

      if (recordLine.Properties.find((x) => x.Name === 'UnitPrice') != null) {
        recordLine.Properties.find((x) => x.Name === 'UnitPrice').Value =
          data.UnitPrice;
        recordLine.Properties.find(
          (x) => x.Name === 'UnitPrice',
        ).ValueAsObject = data.UnitPrice;
      }

      if (recordLine.Properties.find((x) => x.Name === 'Currency') != null) {
        recordLine.Properties.find((x) => x.Name === 'Currency').Value =
          data.Currency;
        recordLine.Properties.find((x) => x.Name === 'Currency').ValueAsObject =
          data.Currency;
      }

      if (recordLine.Properties.find((x) => x.Name === 'UoMEntry') != null) {
        recordLine.Properties.find((x) => x.Name === 'UoMEntry').Value =
          data.UomEntry;
        recordLine.Properties.find((x) => x.Name === 'UoMEntry').ValueAsObject =
          data.UomEntry;
      }

      if (recordLine.Properties.find((x) => x.Name === 'UoMCode') != null) {
        recordLine.Properties.find((x) => x.Name === 'UoMCode').Value =
          data.UomCode;
        recordLine.Properties.find((x) => x.Name === 'UoMCode').ValueAsObject =
          data.UomCode;
      }

      if (recordLine.Properties.find((x) => x.Name === 'VatGroup') != null) {
        recordLine.Properties.find((x) => x.Name === 'VatGroup').Value =
          data.TaxCode;
        recordLine.Properties.find((x) => x.Name === 'VatGroup').ValueAsObject =
          data.TaxCode;
      }

      if (
        recordLine.Properties.find((x) => x.Name === 'U_ITM_BWEB_LINE_GUID') !=
        null
      ) {
        recordLine.Properties.find(
          (x) => x.Name === 'U_ITM_BWEB_LINE_GUID',
        ).Value = Guid.newGuid();
        recordLine.Properties.find(
          (x) => x.Name === 'U_ITM_BWEB_LINE_GUID',
        ).ValueAsObject = Guid.newGuid();
      }

      for (const property1 of recordLine.Properties) {
        const field = section.Fields.find(
          (p) => p.PropertyName === property1.Name,
        );

        if (field.AdditionalInformationParsed.EditableInList) {
          this.layoutService.getFieldValueOnParentChange(
            this.recordModel,
            recordCategory,
            recordLine,
            property1,
            field.SQLStatementParentChanged,
            field,
            this.moduleStructure,
            true,
          );
        }
      }

      if (section.AdditionalInformationParsed.LineTemplate != null) {
        const template = Handlebars.compile(
          section.AdditionalInformationParsed.LineTemplate,
        );
        const html = template(recordLine);
        recordLine.LineTemplateHtml = html;
      }

      if (recordLine.Properties.find((x) => x.Name === 'Quantity') != null) {
        recordLine.Properties.find((x) => x.Name === 'Quantity').Value =
          data.OpenQty;
        recordLine.Properties.find((x) => x.Name === 'Quantity').ValueAsObject =
          data.OpenQty;
      }

      if (
        recordLine.Properties.find((x) => x.Name === 'WarehouseCode') != null &&
        recordLine.Properties.find((x) => x.Name === 'WarehouseCode') !==
          undefined
      ) {
        recordLine.Properties.find((x) => x.Name === 'WarehouseCode').Value =
          data.WhsCode;
        recordLine.Properties.find(
          (x) => x.Name === 'WarehouseCode',
        ).ValueAsObject = data.WhsCode;
      }

      if (
        recordLine.Properties.find((x) => x.Name === 'ShippingMethod') !=
          null &&
        recordLine.Properties.find((x) => x.Name === 'ShippingMethod') !==
          undefined
      ) {
        if (
          data.TrnspCode != null &&
          data.TrnspCode !== undefined &&
          data.TrnspCode !== '-1' &&
          data.TrnspCode !== -1
        ) {
          recordLine.Properties.find((x) => x.Name === 'ShippingMethod').Value =
            data.TrnspCode;
          recordLine.Properties.find(
            (x) => x.Name === 'ShippingMethod',
          ).ValueAsObject = data.TrnspCode;
        } else {
          recordLine.Properties.find((x) => x.Name === 'ShippingMethod').Value =
            TransportationCodeProp.Value;
          recordLine.Properties.find(
            (x) => x.Name === 'ShippingMethod',
          ).ValueAsObject = TransportationCodeProp.ValueAsObject;
        }
      }

      if (
        recordLine.Properties.find((x) => x.Name === 'ShipDate') != null &&
        recordLine.Properties.find((x) => x.Name === 'ShipDate') !== undefined
      ) {
        recordLine.Properties.find((x) => x.Name === 'ShipDate').Value =
          DocDueDateProp.Value;
        recordLine.Properties.find((x) => x.Name === 'ShipDate').ValueAsObject =
          DocDueDateProp.ValueAsObject;

        this.layoutService.triggerFieldValueChanged({
          recordModel: this.recordModel,
          recordProperty: recordLine.Properties.find(
            (x) => x.Name === 'ShipDate',
          ),
          formId: '',
          line: recordLine.Id,
          sectionTagName: recordCategory.Id,
          moduleStructure: this.moduleStructure,
        });
      }

      this.layoutService.linesChanged.emit(recordCategory);
    } else {
      let recordCategory: RecordCategory = null;
      const additionalIdentifier =
        this.documentType === 'I'
          ? 'items'
          : this.documentType === 'P'
            ? 'items'
            : 'services';
      if (
        this.documentType.toLowerCase() == 'services' ||
        this.documentType.toLowerCase() == 's'
      ) {
        data.Quantity = 1;
      }
      const DocCurr = this.recordModel.Categories.find(
        (x) => x.Id == 'Documents',
      )?.Lines[0].Properties.find(
        (x) => x.Name == 'DocCurrency',
      )?.ValueAsObject;
      //if (DocCurr != null && data.Currency != DocCurr) {
      if (data.Currency != g.companyConfiguration.LocalCurrency) {
        this.isForeignCurr = true;
      }

      const NumAtCardProp = this.recordModel.Categories.find(
        (x) => x.Id == 'Documents',
      )?.Lines[0].Properties.find((x) => x.Name == 'NumAtCard');

      if (
        g.copyNumAtCardWhenCopyFrom &&
        NumAtCardProp != null &&
        data.NumAtCard != null &&
        data.NumAtCard != undefined
      ) {
        NumAtCardProp.ValueAsObject = data.NumAtCard;
        NumAtCardProp.Value = data.NumAtCard;
      }

      if (
        g.fieldsTobeCopiedWhenCopyFrom !== '' &&
        !this.fieldShouldCopyIsSetfromDoc
      ) {
        this.fieldShouldCopyIsSetfromDoc = true;
        let listOfFields = g.fieldsTobeCopiedWhenCopyFrom.split(',');
        listOfFields.forEach((fieldName) => {
          const field = this.recordModel.Categories.find(
            (x) => x.Id == 'Documents',
          )?.Lines[0].Properties.find((x) => x.FieldName == fieldName);

          if (
            field != null &&
            data[fieldName] != null &&
            data[fieldName] != undefined
          ) {
            if (
              field.DataType === FieldDataType.Select &&
              (field.Options == null ||
                field.Options === undefined ||
                field.Options.length === 0)
            ) {
              const fieldStructure = this.moduleStructure.module.Sections.find(
                (x) => x.XmlTagName == 'Documents',
              )?.Fields.find(
                (p) => p.PropertyName === field.Name && p.Id === field.FieldId,
              );

              RecordModel.getOptions(
                fieldStructure,
                this.recordModel,
                field,
                recordCategory.Id,
                recordLine.Id,
                recordCategory,
                this.layoutService,
                this.moduleStructure,
              );
            }

            field.ValueAsObject = data[fieldName];
            field.Value = data[fieldName];
          }
        });
      }

      var docsToCopyAddress = g.copyFromAddressForDocuments.split(',');

      if (
        g.fieldsTobeCopiedWhenCopyFromAddress !== '' &&
        docsToCopyAddress.indexOf(this.recordModel.ObjectKey) !== -1 &&
        !this.addressIsSetfromDoc
      ) {
        this.addressIsSetfromDoc = true;
        const addressCat = this.recordModel.Categories.find(
          (x) => x.Id == 'AddressExtension',
        );

        let listOfFields = g.fieldsTobeCopiedWhenCopyFromAddress.split(',');
        listOfFields.forEach((fieldName) => {
          const field = addressCat.Lines[0].Properties.find(
            (x) => x.FieldName == fieldName,
          );

          if (
            field != null /*&&
            data[fieldName] != null &&
            data[fieldName] != undefined*/
          ) {
            if (
              field.DataType === FieldDataType.Select &&
              (field.Options == null ||
                field.Options === undefined ||
                field.Options.length === 0)
            ) {
              const fieldStructure = this.moduleStructure.module.Sections.find(
                (x) => x.XmlTagName == 'AddressExtension',
              )?.Fields.find(
                (p) => p.PropertyName === field.Name && p.Id === field.FieldId,
              );

              RecordModel.getOptions(
                fieldStructure,
                this.recordModel,
                field,
                addressCat.Id,
                0,
                addressCat,
                this.layoutService,
                this.moduleStructure,
              );
            }

            field.ValueAsObject = data[fieldName];
            field.Value = data[fieldName];
          }
        });
      }

      if (
        this.recordModel.ObjectKey === 'oCreditNotes' &&
        g.fieldsTobeCopiedWhenCopyFromForCredit !== ''
      ) {
        let listOfFields = g.fieldsTobeCopiedWhenCopyFromForCredit.split(',');
        listOfFields.forEach((fieldName) => {
          const field = this.recordModel.Categories.find(
            (x) => x.Id == 'Documents',
          )?.Lines[0].Properties.find((x) => x.FieldName == fieldName);

          if (
            field != null &&
            data[fieldName] != null &&
            data[fieldName] != undefined
          ) {
            if (
              field.DataType === FieldDataType.Select &&
              (field.Options == null ||
                field.Options === undefined ||
                field.Options.length === 0)
            ) {
              const fieldStructure = this.moduleStructure.module.Sections.find(
                (x) => x.XmlTagName == 'Documents',
              )?.Fields.find(
                (p) => p.PropertyName === field.Name && p.Id === field.FieldId,
              );

              RecordModel.getOptions(
                fieldStructure,
                this.recordModel,
                field,
                recordCategory.Id,
                recordLine.Id,
                recordCategory,
                this.layoutService,
                this.moduleStructure,
              );
            }

            field.ValueAsObject = data[fieldName];
            field.Value = data[fieldName];

            LayoutService.setValue(
              field,
              data[fieldName],
              this.layoutService,
              this.recordModel,
              0,
              'Documents',
              this.moduleStructure,
              true,
            );
          }
        });
      }

      const section = this.moduleStructure.module.Sections.find(
        (sec) =>
          sec.XmlTagName === 'Document_Lines' &&
          sec.AdditionalIdentifier === additionalIdentifier,
      );
      this.recordModel.Categories.forEach((category) => {
        if (category.Id === section.XmlTagName) {
          recordCategory = category;
          return;
        }
      });

      if (recordCategory == null) {
        recordCategory = {
          Id: section.XmlTagName,
          Lines: [],
          DeletedLines: [],
        };
        this.recordModel.Categories.push(recordCategory);
      }
      if (recordCategory.Lines.length !== 0 && this.maxLineNum === 0) {
        if (
          this.recordModel.ObjectKey === 'InventoryCounting' ||
          this.recordModel.ObjectKey === 'InventoryPosting'
        ) {
          this.maxLineNum =
            Math.max.apply(
              Math,
              recordCategory.Lines.map(
                (o) =>
                  o.Properties.find((prop) => prop.Name === 'LineNumber')
                    .ValueAsObject,
              ),
            ) + 1;
        } else {
          this.maxLineNum =
            Math.max.apply(
              Math,
              recordCategory.Lines.map(
                (o) =>
                  o.Properties.find((prop) => prop.Name === 'LineNum')
                    .ValueAsObject,
              ),
            ) + 1;
        }
      } else {
        this.maxLineNum++;
      }

      let recordLine: RecordLine = null;
      recordLine = {
        Id: recordCategory.Lines.length,
        MaxIndex: this.maxLineNum,
        Properties: [],
      };

      console.log(recordLine);

      RecordModel.refineTheRecordModelLine(
        this.layoutService,
        section,
        recordLine,
        this.defaultVals,
      );

      this.layoutService.lineAdded.emit({
        recordLine,
        moduleStructure: this.moduleStructure,
        section: section,
        recordModel: this.recordModel,
      });

      /*this.layoutService.lineAdded.emit({
      recordLine,
      moduleStructure: this.moduleStructure,
      section: this.moduleStructure.module.Sections.find(
        (sec) => sec.XmlTagName === recordCategory.Id
      ),
      recordModel: this.recordModel,
    });*/

      recordLine.IsNew = true;

      for (const property of recordLine.Properties) {
        //#region handling some errors in service type docs
        if (property.Visible == null) {
          property.Visible = true;
        }
        if (property.ReadOnly == null) {
          property.ReadOnly = false;
        }
        if (property.Required == null) {
          property.Required = false;
        }
        if (property.ValueAsObject == null) {
          property.ValueAsObject = '';
        }
        //#endregion

        const field = section.Fields.find(
          (p) => p.PropertyName === property.Name,
        );
        if (field.ParentProperties != null && field.ParentProperties !== '') {
          let queryIdToExecute = field.SQLStatementParentChanged;
          if (queryIdToExecute == null || queryIdToExecute === 0) {
            queryIdToExecute = field.SQLStatementId;
          }

          if (queryIdToExecute != null && queryIdToExecute !== 0) {
            /*
          this.layoutService.getFieldValueOnParentChange(
            this.recordModel,
            recordCategory,
            recordLine.Id,
            property,
            queryIdToExecute,
            field,
            this.moduleStructure,
            true
          );
          */
          }
        }
      }

      if (this.recordModel.ObjectKey === 'oInventoryGenEntry') {
        recordLine.Properties.find(
          (p) => p.Name === 'BaseEntry',
        ).ValueAsObject = data.DocEntry;
      } else {
        recordLine.Properties.find(
          (p) => p.Name === 'BaseEntry',
        ).ValueAsObject = data.DocEntry;
      }
      recordLine.Properties.find((p) => p.Name === 'BaseType').ValueAsObject =
        objectId;
      if (
        this.recordModel.ObjectKey === 'oInventoryGenExit' ||
        this.recordModel.ObjectKey === 'oInventoryGenEntry'
      ) {
        if (recordLine.Properties.find((p) => p.Name === 'BaseLine') != null) {
          console.log('data.LineNum', data.LineNum);
          console.log('data.LineNum', data.BaseLine);

          recordLine.Properties.find(
            (p) => p.Name === 'BaseLine',
          ).ValueAsObject =
            data.BaseEntry == null ||
            data.BaseEntry === undefined ||
            data.BaseEntry === ''
              ? data.LineNum
              : data.BaseLine;
        }
      } else {
        recordLine.Properties.find((p) => p.Name === 'BaseLine').ValueAsObject =
          data.LineNum;

        if (recordLine.Properties.find((p) => p.Name === 'TreeType') != null) {
          recordLine.Properties.find(
            (p) => p.Name === 'TreeType',
          ).ValueAsObject = data.TreeType;
        }
      }

      recordCategory.Lines = [...recordCategory.Lines, recordLine];
      recordCategory.MaxIndex = this.maxLineNum;

      const doc = new businessDoc.Documents(
        this.layoutService,
        this.message,
        this.modal,
        false,
      );

      if (recordLine.Properties.find((x) => x.Name === 'Quantity') != null) {
        recordLine.Properties.find((x) => x.Name === 'Quantity').Value =
          data.OpenQty;
        recordLine.Properties.find((x) => x.Name === 'Quantity').ValueAsObject =
          data.OpenQty;
      }

      if (
        recordLine.Properties.find((x) => x.Name === 'WarehouseCode') != null &&
        recordLine.Properties.find((x) => x.Name === 'WarehouseCode') !==
          undefined
      ) {
        recordLine.Properties.find((x) => x.Name === 'WarehouseCode').Value =
          data.WhsCode;
        recordLine.Properties.find(
          (x) => x.Name === 'WarehouseCode',
        ).ValueAsObject = data.WhsCode;
      }

      for (const property of recordLine.Properties) {
        if (g.userIdentity.Area == 3) {
          // property.Disabled = true;
          property.ReadOnly = true;
        }
        if (property.Name === 'BaseLine' && this.documentType !== 'P') {
          continue;
        }
        let valueProperty = !data.hasOwnProperty(property.Name)
          ? !data.hasOwnProperty(property.FieldName)
            ? null
            : data[property.FieldName]
          : data[property.Name];

        if (property.Name === 'Quantity') {
          continue;
        }
        if (property.Name === 'TreeType') {
          continue;
        }
        if (
          valueProperty == null &&
          property.Name !== 'TaxValue' &&
          property.Name !== 'BASE_LineTotal'
        ) {
          continue;
        }

        if (
          valueProperty === null &&
          property.Name !== 'LineNum' &&
          property.Name !== 'ItemDescription' &&
          property.Name !== 'TaxValue' &&
          property.Name !== 'BASE_LineTotal'
        ) {
          property.Value = '';
          property.ValueAsObject = '';
        } else if (
          ['LineNum', 'BaseEntry', 'BaseLine', 'BaseType'].indexOf(
            property.Name,
          ) === -1
        ) {
          if (property.Name === 'Currency') {
            const documentSection = this.recordModel.Categories.find(
              (x) => x.Id === 'Documents',
            );
            const currency = documentSection.Lines[0].Properties.find(
              (x) => x.Name === 'DocCurrency',
            );
            if (
              valueProperty.toString() != null &&
              valueProperty.toString() !== undefined &&
              valueProperty.toString() !== ''
            ) {
              currency.Value = valueProperty.toString();
              currency.ValueAsObject = valueProperty;
            }

            // LayoutService.setValue(
            //   currency,
            //   valueProperty,
            //   this.layoutService,
            //   this.recordModel,
            //   0,
            //   'Documents',
            //   this.moduleStructure,
            //   true
            // );
          }

          if (property.Name === 'Rate') {
            const documentSection = this.recordModel.Categories.find(
              (x) => x.Id === 'Documents',
            );
            const docRate = documentSection.Lines[0].Properties.find(
              (x) => x.Name === 'DocRate',
            );
            if (
              valueProperty.toString() != null &&
              valueProperty.toString() !== undefined &&
              valueProperty.toString() !== ''
            ) {
              docRate.Value = valueProperty.toString();
              docRate.ValueAsObject = valueProperty;
            }

            // LayoutService.setValue(
            //   currency,
            //   valueProperty,
            //   this.layoutService,
            //   this.recordModel,
            //   0,
            //   'Documents',
            //   this.moduleStructure,
            //   true
            // );
          }

          if (property.DataType === FieldDataType.Select) {
            const field = section.Fields.find(
              (p) =>
                p.PropertyName === property.Name && p.Id === property.FieldId,
            );

            RecordModel.getOptions(
              field,
              this.recordModel,
              property,
              recordCategory.Id,
              recordLine.Id,
              recordCategory,
              this.layoutService,
              this.moduleStructure,
            );
            property.Value = valueProperty.toString();
            property.ValueAsObject = valueProperty.toString();
          } else {
            if (property.Name.toLocaleLowerCase() === 'priceaftervat') {
              if (
                this.documentType.toLowerCase() == 'services' ||
                this.documentType.toLowerCase() == 's'
              ) {
                data.Quantity = 1;
              }
              const discount =
                data.DiscPrcnt > 1 || data.DiscPrcnt < -1
                  ? data.DiscPrcnt / 100
                  : data.DiscPrcnt;

              //const vatSum = this.isForeignCurr ? data.VatSumFrgn : data.VatSum;
              const vatPrcnt = data.VatPrcnt;
              let price = data.OpenSumFC === 0 ? data.OpenSum : data.OpenSumFC;
              //price = price !== data.PriceBefDi ? price : data.PriceBefDi;
              const vat = (price * vatPrcnt) / 100;
              //const discPrice = price - price * discount;
              const value = price + vat; //data.PriceAfVAT; //discPrice + vat;

              property.Value = value.toString();
              property.ValueAsObject = value;
            } else if (property.Name == 'TaxValue') {
              console.log('Tax Value');
              if (this.isForeignCurr) {
                if (Number(data.VatAppldFC) === 0) {
                  property.ValueAsObject = Number(data.VatSumFrgn);
                } else {
                  property.ValueAsObject =
                    Number(data.VatSumFrgn) - Number(data.VatAppldFC);
                }
              } else {
                if (Number(data.VatAppld) === 0) {
                  property.ValueAsObject = Number(data.VatSum);
                } else {
                  property.ValueAsObject =
                    Number(data.VatSum) - Number(data.VatAppld);
                }
              }
              property.Value = property.ValueAsObject.toString();
            } else if (property.Name == 'TaxCode') {
              console.log('Tax Code');
              /*LayoutService.setValue(
                property,
                data.TaxCode,
                this.layoutService,
                this.recordModel,
                recordLine.Id,
                'Document_Lines',
                this.moduleStructure
              );*/
              property.ValueAsObject = data.TaxCode;
              property.Value = property.ValueAsObject.toString();

              // setTimeout(() => {
              //   this.layoutService.triggerFieldValueChanged({
              //     recordModel: this.recordModel,
              //     recordProperty: property,
              //     formId: '',
              //     line: recordLine.Id,
              //     sectionTagName: 'Document_Lines',
              //     moduleStructure: this.moduleStructure,
              //   });
              // }, 1500);
            } else if (property.Name == 'LineTotal' && this.isForeignCurr) {
              if (g.companyConfiguration.DirectRate === undefined) {
                if (g.foreignIsRateMultplication) {
                  property.ValueAsObject = (valueProperty * data.Rate).toFixed(
                    g.companyConfiguration.AmountDecimal,
                  );
                } else {
                  property.ValueAsObject = (valueProperty / data.Rate).toFixed(
                    g.companyConfiguration.AmountDecimal,
                  );
                }
              } else {
                if (g.companyConfiguration.DirectRate === 'N') {
                  property.ValueAsObject = (valueProperty * data.Rate).toFixed(
                    g.companyConfiguration.AmountDecimal,
                  );
                } else {
                  property.ValueAsObject = (valueProperty / data.Rate).toFixed(
                    g.companyConfiguration.AmountDecimal,
                  );
                }
              }
              if (
                (this.documentType.toLowerCase() == 'items' ||
                  this.documentType.toLowerCase() == 'i') &&
                data.OpenQty !== 0
              ) {
                property.ValueAsObject =
                  data.OpenQty * data.PriceBefDi -
                  (data.OpenQty * data.PriceBefDi * data.DiscPrcnt) / 100;
              } else {
                property.ValueAsObject =
                  data.PriceBefDi - (data.PriceBefDi * data.DiscPrcnt) / 100;
              }

              property.Value = property.ValueAsObject.toString();

              const baseLineTotal = recordLine.Properties.find(
                (x) => x.Name === 'BASE_LineTotal',
              );

              if (baseLineTotal != null && baseLineTotal !== undefined) {
                baseLineTotal.ValueAsObject = property.ValueAsObject;
                baseLineTotal.Value = baseLineTotal.ValueAsObject.toString();
              }
            } else if (
              property.Name == 'BASE_LineTotal' &&
              !this.isForeignCurr
            ) {
              property.ValueAsObject = data.LineTotal;
              property.Value = property.ValueAsObject.toString();
            } else if (property.Name == 'UnitPrice') {
              const value = data.PriceBefDi;
              const discount =
                //data.DiscPrcnt > 1 || data.DiscPrcnt < -1
                //  ? data.DiscPrcnt / 100
                //:
                data.DiscPrcnt;

              if (
                this.documentType.toLowerCase() == 'items' ||
                this.documentType.toLowerCase() == 'i'
              ) {
                if (this.isForeignCurr) {
                  if (g.companyConfiguration.DirectRate === undefined) {
                    if (g.foreignIsRateMultplication) {
                      data.PriceBefDi =
                        (data.LineTotal * data.Rate) /
                        (data.Quantity - (data.Quantity * discount) / 100);
                    } else {
                      data.PriceBefDi =
                        data.LineTotal /
                        data.Rate /
                        (data.Quantity - (data.Quantity * discount) / 100);
                    }
                  } else {
                    if (g.companyConfiguration.DirectRate === 'N') {
                      data.PriceBefDi =
                        (data.LineTotal * data.Rate) /
                        (data.Quantity - (data.Quantity * discount) / 100);
                    } else {
                      data.PriceBefDi =
                        data.LineTotal /
                        data.Rate /
                        (data.Quantity - (data.Quantity * discount) / 100);
                    }
                  }
                } else {
                  data.PriceBefDi =
                    data.LineTotal /
                    (data.Quantity - (data.Quantity * discount) / 100);
                }
              } else {
                if (this.isForeignCurr) {
                  if (g.companyConfiguration.DirectRate === undefined) {
                    if (g.foreignIsRateMultplication) {
                      data.PriceBefDi =
                        (data.OpenSum * data.Rate) /
                        (data.Quantity - (data.Quantity * discount) / 100);
                    } else {
                      data.PriceBefDi =
                        data.OpenSum /
                        data.Rate /
                        (data.Quantity - (data.Quantity * discount) / 100);
                    }
                  } else {
                    if (g.companyConfiguration.DirectRate === 'N') {
                      data.PriceBefDi =
                        (data.OpenSum * data.Rate) /
                        (data.Quantity - (data.Quantity * discount) / 100);
                    } else {
                      data.PriceBefDi =
                        data.OpenSum /
                        data.Rate /
                        (data.Quantity - (data.Quantity * discount) / 100);
                    }
                  }
                } else {
                  data.PriceBefDi =
                    data.OpenSum /
                    (data.Quantity - (data.Quantity * discount) / 100);
                }
              }

              //property.ValueAsObject = data.PriceBefDi;
              if (Math.abs(data.PriceBefDi - value) < 0.03) {
                data.PriceBefDi = value;
              }
              property.ValueAsObject = data.PriceBefDi;
              property.Value = property.ValueAsObject.toString();
            } else if (property.Name == 'ItemCode') {
              let treeTypeProp = recordLine.Properties.find(
                (p) => p.Name === 'TreeType',
              );
              if (treeTypeProp != null && treeTypeProp !== undefined) {
                let treeType = treeTypeProp.ValueAsObject;
                if (treeType === 'S' || treeType === 'iSalesTree') {
                  this.parentItemCode = valueProperty.toString();
                } else if (treeType === 'I' || treeType === 'iIngredient') {
                  recordLine.Properties.find(
                    (p) => p.Name === 'U_ITM_BWEB_PARENT_ITEM',
                  ).Value = this.parentItemCode;
                  recordLine.Properties.find(
                    (p) => p.Name === 'U_ITM_BWEB_PARENT_ITEM',
                  ).ValueAsObject = this.parentItemCode;

                  this.layoutService.triggerFieldValueChanged({
                    recordModel: this.recordModel,
                    recordProperty: recordLine.Properties.find(
                      (p) => p.Name === 'U_ITM_BWEB_PARENT_ITEM',
                    ),
                    formId: '',
                    line: recordLine.Id,
                    sectionTagName: 'Document_Lines',
                    moduleStructure: this.moduleStructure,
                  });
                }
              }

              property.Value = valueProperty.toString();
              property.ValueAsObject = valueProperty;
              this.layoutService.triggerFieldValueChangedCustom({
                recordModel: this.recordModel,
                recordProperty: property,
                formId: '',
                line: recordLine.Id,
                sectionTagName: 'Document_Lines',
                moduleStructure: this.moduleStructure,
              });
            } else {
              property.Value = valueProperty?.toString();
              property.ValueAsObject = valueProperty;
            }
          }

          // Set Value commented in order to keep line's value as it is
        }

        doc.oDocuments_TotalCalc(
          {
            formId: this.recordModel.FormGUID,
            line: 0,
            moduleStructure: this.moduleStructure,
            recordModel: this.recordModel,
            recordProperty: property,
            sectionTagName: '',
          },
          true,
        );
      }

      for (const property1 of recordLine.Properties) {
        const field = section.Fields.find(
          (p) => p.PropertyName === property1.Name,
        );

        if (field.AdditionalInformationParsed.EditableInList) {
          this.layoutService.getFieldValueOnParentChange(
            this.recordModel,
            recordCategory,
            recordLine,
            property1,
            field.SQLStatementParentChanged,
            field,
            this.moduleStructure,
            true,
          );
        }
      }

      if (
        tableName === 'INV' &&
        this.recordModel.ObjectKey === 'oCreditNotes' &&
        this.documentType === 'I'
      )
        if (
          recordLine.Properties.find(
            (x) => x.Name === 'WithoutInventoryMovement',
          ) != null
        ) {
          recordLine.Properties.find(
            (x) => x.Name === 'WithoutInventoryMovement',
          ).Value = 'Y';
          recordLine.Properties.find(
            (x) => x.Name === 'WithoutInventoryMovement',
          ).ValueAsObject = 'Y';
        }

      if (section.AdditionalInformationParsed.LineTemplate != null) {
        const template = Handlebars.compile(
          section.AdditionalInformationParsed.LineTemplate,
        );
        const html = template(recordLine);
        recordLine.LineTemplateHtml = html;
      }

      // Set Value commented in order to keep line's value as it is
      // LayoutService.setValue(
      //   recordLine.Properties.find((p) => p.Name === 'Quantity'),
      //   data.OpenQty,
      //   this.layoutService,
      //   this.recordModel,
      //   recordCategory.Lines.length - 1,
      //   'Document_Lines',
      //   this.moduleStructure
      // );

      this.layoutService.linesChanged.emit(recordCategory);
    }
  }

  setChildChecked(dataSourceId, docRow) {
    console.log('setChildChecked');

    let index = 0;
    let checked = docRow.Selected;
    if (this.displayMinimizedRows) {
      for (let i = 0; i < this.openDocumentRows[dataSourceId].length; i++) {
        const row = this.openDocumentRows[dataSourceId][i];
        if (row.DocEntry === docRow.DocEntry) {
          row.Selected = checked;
        }
      }
    } else {
      const currentObject = this.recordModel.ObjectKey;
      if (currentObject === 'BlanketAgreement') {
        for (let i = 0; i < this.openDocumentRows[dataSourceId].length; i++) {
          const row = this.openDocumentRows[dataSourceId][i];
          if (row.DocEntry === docRow.DocEntry) {
            row.Selected = checked;
          }
        }
      } else {
        for (let i = 0; i < this.openDocumentRows[dataSourceId].length; i++) {
          const row = this.openDocumentRows[dataSourceId][i];
          if (
            row.DocEntry === docRow.DocEntry &&
            row.LineNum === docRow.LineNum
          ) {
            index = i;
            break;
          }
        }

        for (let i = 0; i < this.openDocumentRows[dataSourceId].length; i++) {
          const row = this.openDocumentRows[dataSourceId][i];
          if (i > index && row.TreeType === 'I') {
            row.Selected = checked;
          }
          if (i > index && row.TreeType !== 'I') {
            break;
          }
        }
      }
    }
  }

  applyFilters(id) {
    console.log(this.filters);
    const currentObject = this.recordModel.ObjectKey;
    if (currentObject === 'BlanketAgreement') {
      this.filteredData = this.minimizedOpenDocumentRowsForBA[id].filter(
        (row) =>
          (!this.filters.docNum ||
            row.DocNum.toString()
              .toLowerCase()
              .includes(this.filters.docNum.toString().toLowerCase())) &&
          (!this.filters.quotName ||
            (row.QuotName != null &&
              row.QuotName.toString()
                .toLowerCase()
                .includes(this.filters.quotName.toString().toLowerCase()))) &&
          (!this.filters.numAtCard ||
            (row.NumAtCard != null &&
              row.NumAtCard.toString()
                .toLowerCase()
                .includes(this.filters.numAtCard.toString().toLowerCase()))),
      );
    } else if (this.displayMinimizedRows) {
      this.filteredData = this.openDocumentRows[id].filter(
        (row) =>
          (!this.filters.docNum ||
            row.DocNum.toString()
              .toLowerCase()
              .includes(this.filters.docNum.toString().toLowerCase())) &&
          (!this.filters.itemCode ||
            row.ItemCode.toString()
              .toLowerCase()
              .includes(this.filters.itemCode.toString().toLowerCase())) &&
          (!this.filters.description ||
            row.Dscription.toString()
              .toLowerCase()
              .includes(this.filters.description.toString().toLowerCase())) &&
          (!this.filters.numAtCard ||
            (row.NumAtCard != null &&
              row.NumAtCard.toString()
                .toLowerCase()
                .includes(this.filters.numAtCard.toString().toLowerCase()))),
      );
    } else {
      this.filteredData = this.openDocumentRows[id].filter(
        (row) =>
          (!this.filters.docNum ||
            row.DocNum.toString()
              .toLowerCase()
              .includes(this.filters.docNum.toString().toLowerCase())) &&
          (!this.filters.quotName ||
            (row.QuotName != null &&
              row.QuotName.toString()
                .toLowerCase()
                .includes(this.filters.quotName.toString().toLowerCase()))) &&
          (!this.filters.itemCode ||
            row.ItemCode.toString()
              .toLowerCase()
              .includes(this.filters.itemCode.toString().toLowerCase())) &&
          (!this.filters.description ||
            row.Dscription.toString()
              .toLowerCase()
              .includes(this.filters.description.toString().toLowerCase())) &&
          (!this.filters.salesSource ||
            row.SalesSource === this.filters.salesSource) &&
          (!this.filters.numAtCard ||
            (row.NumAtCard != null &&
              row.NumAtCard.toString()
                .toLowerCase()
                .includes(this.filters.numAtCard.toString().toLowerCase())) ||
            (row.NumAtCard_D != null &&
              row.NumAtCard_D.toString()
                .toLowerCase()
                .includes(this.filters.numAtCard.toString().toLowerCase()))),
      );
    }
  }

  addSelectedRows() {
    const Lines = [];
    let productionOrderReferenced: boolean;
    let shouldCallTotalCalc = false;

    this.documentSources.forEach((source) => {
      this.openDocumentRows[source.Id].forEach((row) => {
        if (row.Selected === true) {
          if (source.Id === '202') {
            productionOrderReferenced = true;
          }
          if (source.TableName === 'OAT') {
            shouldCallTotalCalc = true;
          }
          console.log('Row to be copied', row);
          this.addLineToTable(row, source.Id, source.TableName);
          let IsExist = false;
          Lines.forEach((line) => {
            if (line.DocEntry === row.DocEntry && line.ObjType === source.Id) {
              IsExist = true;
              return;
            }
          });
          if (IsExist === false && this.documentType !== 'P') {
            Lines.push({
              DocEntry: row.DocEntry,
              ObjType: source.Id,
            });
            /*this.AddFreightToDocument(
              rows[j].DocEntry,
              this.documentSources[i].Id
            );*/
          }
        }
      });
    });

    if (shouldCallTotalCalc) {
      setTimeout(() => {
        var propsToCheck =
          'Document_Lines.UnitPrice,Document_Lines.ShipDate'.split(',');

        propsToCheck.forEach((p) => {
          let catId = p.split('.')[0];
          let propName = p.split('.')[1];
          let recordCategory = this.recordModel.Categories.find(
            (category) => category.Id === catId,
          );

          if (recordCategory != null && recordCategory !== undefined) {
            for (const recordLine of recordCategory.Lines) {
              const prop = recordLine.Properties.find(
                (a) => a.Name === propName,
              );

              if (prop != null && prop !== undefined) {
                this.layoutService.triggerFieldValueChanged({
                  recordModel: this.recordModel,
                  recordProperty: prop,
                  formId: '',
                  line: recordLine.Id,
                  sectionTagName: catId,
                  moduleStructure: this.moduleStructure,
                });
              }
            }
          }
        });

        let billOfMaterials = new BillOfMaterials(
          this.layoutService,
          this.message,
          this.billOfMaterialService,
          false,
        );

        let recordCategory = this.recordModel.Categories.find(
          (category) => category.Id === 'Document_Lines',
        );

        if (recordCategory != null && recordCategory !== undefined) {
          for (const recordLine of recordCategory.Lines) {
            const prop = recordLine.Properties.find(
              (a) => a.Name === 'ItemCode',
            );

            if (prop != null && prop !== undefined) {
              billOfMaterials.LoadBOMItems({
                recordModel: this.recordModel,
                recordProperty: prop,
                formId: '',
                line: recordLine.Id,
                sectionTagName: 'Document_Lines',
                moduleStructure: this.moduleStructure,
              });
            }
          }
        }
      }, 2000);
    }

    // console.log('Lines>>', Lines);
    if (Lines.length === 1 && this.documentType !== 'P') {
      // this.FillAddresses(Lines[0].DocEntry, Lines[0].ObjType);
    }

    if (this.recordModel.ObjectTypeValue === '13') {
      // #region commented code
      /*$http({
        url: 'Document/GetSumDownPaymentAmount',
        method: 'POST',
        data: { SelectedLineSource: Lines },
      }).then(function successCallback(response) {
        DownPaymentAmount = response.data;
        //console.log({ 'response.data': response.data });
        // console.log({ 'control': $('[name="Documents.ITM_DPM_AMOUNT"]',
         form), 'itmFAmount(DownPaymentAmount)': itmFAmount(DownPaymentAmount) });
        $('[name="Documents.ITM_DPM_AMOUNT"]', form).val(
          itmFAmount(DownPaymentAmount)
        );
      });*/
      //#endregion
    }
    if (productionOrderReferenced === true) {
      const document = this.recordModel.Categories.find(
        (x) => x.Id === 'Documents',
      ).Lines[0];
      const documentLines = this.recordModel.Categories.find(
        (x) => x.Id === 'Document_Lines',
      );

      const modStructDocument = this.moduleStructure.module.Sections.find(
        (x) => x.XmlTagName === 'Documents',
      );
      const modStructDocLines = this.moduleStructure.module.Sections.find(
        (x) => x.XmlTagName === 'Document_Lines',
      );
      const taxDate = document.Properties.find((x) => x.Name === 'TaxDate');
      if (taxDate) {
        taxDate.Value = '';
        taxDate.ValueAsObject = null;
        taxDate.Required = false;
      }

      const paymentGroup = document.Properties.find(
        (x) => x.Name === 'PaymentGroupCode',
      );
      if (paymentGroup) {
        paymentGroup.Value = paymentGroup.ValueAsObject = null;
        paymentGroup.Required = false;
        paymentGroup.Disabled = true;
      }
      const mod = modStructDocument.Fields.find(
        (z) => z.PropertyName === 'PaymentGroupCode',
      );
      if (mod) {
        mod.Required = false;
        mod.Disabled = true;
      }

      // const docDueDate = document.Properties.find(x => x.Name === 'DocDueDate');
      // docDueDate.Value = docDueDate.ValueAsObject = null;
      // docDueDate.Required = false;
      // docDueDate.Disabled = true;
      documentLines.Lines.forEach((line) => {
        const itemCode = line.Properties.find((x) => x.Name === 'ItemCode');
        itemCode.Disabled = true;
      });
      modStructDocLines.Fields.forEach((field) => {
        if (field.PropertyName === 'ItemCode') {
          field.Disabled = true;
        }
      });
    }
    this.showCopyFromDrawer = false;
  }

  openCopyFromDrawer() {
    const currentObject = this.recordModel.ObjectKey;
    if (currentObject === 'BlanketAgreement') {
      this.documentType = 'BI';
      const headerCat = this.recordModel.Categories.find(
        (cat) => cat.Id === 'BlanketAgreement',
      );

      if (
        headerCat != null &&
        headerCat !== undefined &&
        headerCat.Lines != null &&
        headerCat.Lines !== undefined &&
        headerCat.Lines.length !== 0
      ) {
        const cardCodeProp = headerCat.Lines[0].Properties.find(
          (prop) => prop.Name === 'BPCode',
        );
        let cardCode = '';
        if (cardCodeProp != null && cardCodeProp !== undefined) {
          cardCode = headerCat.Lines[0].Properties.find(
            (prop) => prop.Name === 'BPCode',
          ).ValueAsObject;
        }

        if (cardCode == null || cardCode === undefined || cardCode === '') {
          this.notificationService.error(
            this.layoutService.translate('Error'),
            this.layoutService.translate(
              'Please select a business partner before.',
            ),
          );
          return;
        }

        const openSourceDoc$ = this.layoutService
          .getSourceDocument(this.moduleStructure.module.Id)
          .subscribe((d: any) => {
            this.showCopyFromDrawer = true;
            this.documentSources = d.SourceDocuments;
            if (this.documentSources.length === 0) {
              this.notificationService.error(
                this.layoutService.translate('No Source Documents'),
                this.layoutService.translate(
                  'Please be sure that you have at least one source document.',
                ),
              );
              return;
            }
            console.log(this.documentSources);
            this.documentSources.forEach((source) => {
              this.minimizedOpenDocumentRowsForBA[source.Id] = [];
              this.openDocumentRows[source.Id] = [];
              const openDocumentRows$ = this.layoutService
                .getOpenDocumentRows(
                  this.moduleId.toString(),
                  source.TableName + (source.IsReserved ? '_R' : ''),
                  cardCode,
                  this.documentType,
                )
                .subscribe((result: any) => {
                  this.openDocumentRows[source.Id] = result.Rows;

                  if (source.Id === '23') {
                    this.openDocumentRows[source.Id] = this.openDocumentRows[
                      source.Id
                    ].filter(
                      (element) =>
                        this.recordModel.copiedQuotEntries.findIndex(
                          (DocEntry) =>
                            DocEntry === element.DocEntry.toString(),
                        ) === -1,
                    );
                  }
                  this.minimizedOpenDocumentRowsForBA[source.Id] = Array.from(
                    new Map(
                      this.openDocumentRows[source.Id].map((item) => [
                        item.DocEntry, // Use DocEntry as a unique key for grouping
                        {
                          NumAtCard: item.NumAtCard,
                          DocEntry: item.DocEntry,
                          DocNum: item.DocNum,
                          DocDate: item.DocDate,
                          DocDueDate: item.DocDueDate,
                          DocEntry1: item.DocEntry1,
                          QuotName: item.QuotName,
                        },
                      ]),
                    ).values(),
                  );

                  this.minimizedOpenDocumentRowsForBA[source.Id].forEach(
                    (element) => {
                      element.Selected = false;
                    },
                  );

                  this.openDocumentRows[source.Id].forEach((element) => {
                    element.Selected = false;
                  });
                  console.log(this.openDocumentRows);

                  this.filteredData =
                    this.minimizedOpenDocumentRowsForBA[
                      this.documentSources[0].Id
                    ];
                });
              this.subscriptions.push(openDocumentRows$);
            });
          });
        this.subscriptions.push(openSourceDoc$);
      }
    } else {
      const headerCat = this.recordModel.Categories.find(
        (cat) => cat.Id === 'Documents',
      );
      if (
        headerCat != null &&
        headerCat !== undefined &&
        headerCat.Lines != null &&
        headerCat.Lines !== undefined &&
        headerCat.Lines.length !== 0
      ) {
        const cardCodeProp = headerCat.Lines[0].Properties.find(
          (prop) => prop.Name === 'CardCode',
        );
        let cardCode = '';
        if (cardCodeProp != null && cardCodeProp !== undefined) {
          cardCode = headerCat.Lines[0].Properties.find(
            (prop) => prop.Name === 'CardCode',
          ).ValueAsObject;
        }
        const documentTypeProp = headerCat.Lines[0].Properties.find(
          (prop) => prop.Name === 'DocType',
        );
        if (documentTypeProp != null && documentTypeProp !== undefined) {
          // this.documentType = documentTypeProp.Value;
          this.documentType =
            documentTypeProp.ValueAsObject === 'dDocument_Service' ||
            documentTypeProp.ValueAsObject.toLowerCase() === 's'
              ? 'S'
              : documentTypeProp.ValueAsObject === 'dDocument_Items' ||
                  documentTypeProp.ValueAsObject.toLowerCase() === 'i'
                ? 'I'
                : documentTypeProp.Value;
        }

        if (
          (cardCode == null || cardCode === undefined || cardCode === '') &&
          currentObject !== 'oInventoryGenEntry' &&
          currentObject !== 'oInventoryGenExit'
        ) {
          this.notificationService.error(
            this.layoutService.translate('Error'),
            this.layoutService.translate(
              'Please select a business partner before.',
            ),
          );
          return;
        }

        if (
          cardCode === '' &&
          (currentObject === 'oInventoryGenEntry' ||
            currentObject === 'oInventoryGenExit')
        ) {
          this.documentType = 'P';
        }

        const openSourceDoc$ = this.layoutService
          .getSourceDocument(this.moduleStructure.module.Id)
          .subscribe((d: any) => {
            this.showCopyFromDrawer = true;
            this.documentSources = d.SourceDocuments;
            if (this.documentSources.length === 0) {
              this.notificationService.error(
                this.layoutService.translate('No Source Documents'),
                this.layoutService.translate(
                  'Please be sure that you have at least one source document.',
                ),
              );
              return;
            }
            console.log(this.documentSources);
            this.documentSources.forEach((source) => {
              this.minimizedOpenDocumentRows[source.Id] = [];
              this.openDocumentRows[source.Id] = [];
              const openDocumentRows$ = this.layoutService
                .getOpenDocumentRows(
                  this.moduleId.toString(),
                  source.TableName + (source.IsReserved ? '_R' : ''),
                  cardCode,
                  this.documentType,
                )
                .subscribe((result: any) => {
                  this.openDocumentRows[source.Id] = result.Rows;
                  this.minimizedOpenDocumentRows[source.Id] = Array.from(
                    new Map(
                      result.Rows.map((item) => [
                        item.DocEntry, // Use DocEntry as a unique key for grouping
                        {
                          NumAtCard: item.NumAtCard,
                          DocEntry: item.DocEntry,
                          DocNum: item.DocNum,
                          DocDate: item.DocDate,
                          DocDueDate: item.DocDueDate,
                          DocEntry1: item.DocEntry1,
                        },
                      ]),
                    ).values(),
                  );

                  this.minimizedOpenDocumentRows[source.Id].forEach(
                    (element) => {
                      element.Selected = false;
                    },
                  );

                  this.openDocumentRows[source.Id].forEach((element) => {
                    element.Selected = false;
                  });
                  console.log(this.openDocumentRows);

                  if (this.displayMinimizedRows) {
                    this.filteredData =
                      this.minimizedOpenDocumentRows[
                        this.documentSources[0].Id
                      ];
                  } else {
                    this.filteredData =
                      this.openDocumentRows[this.documentSources[0].Id];
                  }
                });
              this.subscriptions.push(openDocumentRows$);
            });
          });
        this.subscriptions.push(openSourceDoc$);
      }
    }
  }

  getTabTitle(documentSource: any): string {
    const id = documentSource.Id;

    if (this.documentType === 'BI') {
      const count = this.minimizedOpenDocumentRowsForBA?.[id]?.length ?? 0;
      return `(${count}) ${documentSource.Name}`;
    }

    if (!this.displayMinimizedRows) {
      const count = this.openDocumentRows?.[id]?.length ?? 0;
      return `(${count}) ${documentSource.Name}`;
    }

    const count = this.minimizedOpenDocumentRows?.[id]?.length ?? 0;
    return `(${count}) ${documentSource.Name}`;
  }

  onTabSelect(documentSource: any): void {
    const id = documentSource.Id;
    this.filteredData = this.openDocumentRows?.[id] ?? [];
  }

  getTabCount(documentSource: any): number {
    const id = documentSource.Id;

    if (this.documentType === 'BI') {
      return this.minimizedOpenDocumentRowsForBA?.[id]?.length ?? 0;
    }

    return this.displayMinimizedRows
      ? (this.minimizedOpenDocumentRows?.[id]?.length ?? 0)
      : (this.openDocumentRows?.[id]?.length ?? 0);
  }

  submitObject(
    fromApproval = false,
    saveAsDraft = false,
    copyFrom = false,
    newVersion = false,
    callback?: (result) => boolean,
  ) {
    if (
      this.moduleStructure.module.AdditionalInformationParsed
        .DisplayConfirmationMessage
    ) {
      const confirmResult = confirm(
        this.moduleStructure.module.AdditionalInformationParsed
          .ConfirmationMessageText,
      );
      if (!confirmResult) {
        return;
      }
    }

    if (this.actionType === 'View' && !this.allowUpdateWnenClose) {
      this.backButtonClicked.emit();
      return;
    }

    if (!fromApproval) {
      this.approvalTemplates = [];
    }

    this.submitting = true;
    this.submittingModel = true;
    businessPayment.Payments.validateBeforeSubmit(this.recordModel);

    const validateMsg = businessDoc.Documents.validateBeforeSubmit(
      this.recordModel,
    );
    businessPayment.Payments.validateBeforeSubmit(this.recordModel);

    if (validateMsg !== '') {
      this.notificationService.error(
        this.layoutService.translate('Error'),
        validateMsg,
      );
      this.submitting = false;
      this.submittingModel = false;
      return;
    }
    if (this.recordModel.ObjectTypeValue === '202') {
      this.handlePOTextLines();
    }
    this.layoutService.triggerBeforeSubmit(this.recordModel);

    let isDocuments = LayoutService.isDocument(this.recordModel.ObjectKey);
    if (
      !isDocuments &&
      (this.recordModel.ObjectKey === 'oStockTransfer' ||
        this.recordModel.ObjectKey === 'oInventoryTransferRequest')
    ) {
      isDocuments = true;
    }

    //BillOfMaterials.validateBeforeSubmit(this.recordModel);
    if (
      LayoutService.isDocument(this.recordModel.ObjectKey) &&
      this.checkBaseTotalForDocuments()
    ) {
      let continueExecute = true;
      const documentLines = this.recordModel.Categories.find(
        (x) => x.Id === 'Document_Lines',
      );

      for (let index = 0; index < documentLines.Lines.length; index++) {
        const line = documentLines.Lines[index];
        const lineTotal = line.Properties.find((x) => x.Name === 'LineTotal');
        const baseLineTotal = line.Properties.find(
          (x) => x.Name === 'BASE_LineTotal',
        );
        if (
          lineTotal != null &&
          lineTotal !== undefined &&
          baseLineTotal != null &&
          baseLineTotal !== undefined
        ) {
          if (
            Number(Number(baseLineTotal.ValueAsObject).toFixed(2)) > 0 &&
            Number(Number(lineTotal.ValueAsObject).toFixed(2)) >
              Number(Number(baseLineTotal.ValueAsObject).toFixed(2))
          ) {
            console.log(Number(Number(baseLineTotal.ValueAsObject).toFixed(2)));
            console.log(Number(Number(lineTotal.ValueAsObject).toFixed(2)));

            this.submittingModel = false;
            continueExecute = false;
            this.modal.confirm({
              nzTitle: this.layoutService.translate(
                'Credit note total greater than open balance amount. Continue?',
              ),
              nzOkText: this.layoutService.translate('Yes'),
              nzCancelText: this.layoutService.translate('No'),
              nzOnOk: () => {
                this.doSubmit(
                  isDocuments,
                  fromApproval,
                  saveAsDraft,
                  copyFrom,
                  newVersion,
                  callback,
                );
              },
              nzOnCancel: () => {
                this.submitting = false;
                this.submittingModel = false;
              },
            });
            break;
          }
        }
      }

      if (continueExecute) {
        this.doSubmit(
          isDocuments,
          fromApproval,
          saveAsDraft,
          copyFrom,
          newVersion,
          callback,
        );
      }

      /*const modStructDocument = this.moduleStructure.module.Sections.find(
        (x) => x.XmlTagName === 'Documents'
      );*/
    } else if (
      LayoutService.isDocument(this.recordModel.ObjectKey) &&
      this.checkItemsInBaseDocument()
    ) {
      let continueExecute = true;
      const documentLines = this.recordModel.Categories.find(
        (x) => x.Id === 'Document_Lines',
      );

      let itemsExceedQuantity: { [key: string]: number } = {};
      let baseDocEntry = 0;
      let baseDocType = 0;
      for (let index = 0; index < documentLines.Lines.length; index++) {
        const line = documentLines.Lines[index];
        const baseEntry = line.Properties.find((x) => x.Name === 'BaseEntry');
        const baseType = line.Properties.find((x) => x.Name === 'BaseType');
        if (
          baseEntry != null &&
          baseEntry !== undefined &&
          Number(baseEntry.ValueAsObject) !== 0
        ) {
          baseDocEntry = baseEntry.ValueAsObject;
          baseDocType = baseType.ValueAsObject;
          break;
        }
      }

      const checks: Observable<string | null>[] = [];

      for (let index = 0; index < documentLines.Lines.length; index++) {
        const line = documentLines.Lines[index];
        const baseEntry = line.Properties.find((x) => x.Name === 'BaseEntry');
        const itemCode = line.Properties.find(
          (x) => x.Name === 'ItemCode',
        ).ValueAsObject;
        const treeType = line.Properties.find(
          (x) => x.Name === 'TreeType',
        ).ValueAsObject;
        if (treeType === 'I' || treeType === 'iIngredient') {
          continue;
        }
        if (baseEntry != null && baseEntry !== undefined) {
          if (Number(baseEntry.ValueAsObject) === 0) {
            continueExecute = false;
            const query$: Observable<string | null> = this.layoutService
              .executeQuery(g.checkItemsInBaseDocumentQueryId, {
                ItemCode: itemCode,
                BaseEntry: baseDocEntry,
              })
              // If you know the shape of the response, you can cast it:
              .pipe(
                map((result: any[]) => {
                  if (result.length === 0) {
                    return itemCode;
                  } else {
                    const baseLine = result[0].LineNum;
                    const openQty = result[0].OpenQty;
                    line.Properties.find(
                      (x) => x.Name === 'BaseEntry',
                    ).ValueAsObject = baseDocEntry;
                    line.Properties.find(
                      (x) => x.Name === 'BaseType',
                    ).ValueAsObject = baseDocType;
                    line.Properties.find(
                      (x) => x.Name === 'BaseLine',
                    ).ValueAsObject = baseLine;

                    line.Properties.find(
                      (x) => x.Name === 'OpenQty',
                    ).ValueAsObject = openQty;

                    const quantityElement = line.Properties.find(
                      (prop) => prop.Name === 'Quantity',
                    );

                    const lineNumProp = line.Properties.find(
                      (p) => p.Name === 'LineNum',
                    );

                    if (Number(quantityElement.ValueAsObject) > openQty) {
                      itemsExceedQuantity[
                        itemCode + '|' + lineNumProp.ValueAsObject
                      ] = openQty;
                    }

                    return null;
                  }
                }),
              );

            checks.push(query$);
          } else {
            //check if quantity exceed open quantity
            const quantityElement = line.Properties.find(
              (prop) => prop.Name === 'Quantity',
            );
            const openQty = line.Properties.find((p) => p.Name === 'OpenQty');
            const lineNumProp = line.Properties.find(
              (p) => p.Name === 'LineNum',
            );

            if (
              Number(quantityElement.ValueAsObject) >
              Number(openQty.ValueAsObject)
            ) {
              continueExecute = false;
              itemsExceedQuantity[itemCode + '|' + lineNumProp.ValueAsObject] =
                openQty.ValueAsObject;
            }
          }
        }
      }

      if (checks.length === 0) {
        if (Object.keys(itemsExceedQuantity).length > 0) {
          const confirmationMsg = `Items ${Object.keys(itemsExceedQuantity)
            .map((k) => k.split('|')[0])
            .join(',')} Exceeds the Quoted qty, Change Qty to Open Qty?`;
          this.modal.confirm({
            nzTitle: this.layoutService.translate(confirmationMsg),
            nzOkText: this.layoutService.translate('Yes'),
            nzCancelText: this.layoutService.translate('No'),
            nzOnOk: () => {
              for (const key in itemsExceedQuantity) {
                const lineNum = key.substring(key.lastIndexOf('|') + 1);
                const quantity = itemsExceedQuantity[key];
                const line = documentLines.Lines.find(
                  (l) =>
                    l.Properties.find(
                      (p) => p.Name === 'LineNum',
                    ).ValueAsObject.toString() === lineNum.toString(),
                );
                const quantityProp = line.Properties.find(
                  (p) => p.Name === 'Quantity',
                );
                quantityProp.ValueAsObject = quantity;

                LayoutService.setValue(
                  quantityProp,
                  quantity,
                  this.layoutService,
                  this.recordModel,
                  line.Id,
                  documentLines.Id,
                  this.moduleStructure,
                  true,
                );
              }

              this.doSubmit(
                isDocuments,
                fromApproval,
                saveAsDraft,
                copyFrom,
                newVersion,
                callback,
              );
            },
            nzOnCancel: () => {
              this.doSubmit(
                isDocuments,
                fromApproval,
                saveAsDraft,
                copyFrom,
                newVersion,
                callback,
              );
            },
          });
        } else {
          this.doSubmit(
            isDocuments,
            fromApproval,
            saveAsDraft,
            copyFrom,
            newVersion,
            callback,
          );
        }
      } else {
        forkJoin(checks).subscribe((results: Array<string | null>) => {
          const itemsOutOfBase = results.filter(
            (code) => code !== null,
          ) as string[];
          let confirmationMsg = '';
          if (
            itemsOutOfBase.length > 0 &&
            Object.keys(itemsExceedQuantity).length > 0
          ) {
            confirmationMsg = `Order contains Items ${itemsOutOfBase.join(
              ',',
            )} which are not present in the Quote - Would you like to Copy them over as well?`;
            this.modal.confirm({
              nzTitle: this.layoutService.translate(confirmationMsg),
              nzOkText: this.layoutService.translate('Yes'),
              nzCancelText: this.layoutService.translate('No'),
              nzOnOk: () => {
                confirmationMsg = `Items ${Object.keys(itemsExceedQuantity)
                  .map((k) => k.split('|')[0])
                  .join(',')} Exceeds the Quoted qty, Change Qty to Open Qty?`;
                this.modal.confirm({
                  nzTitle: this.layoutService.translate(confirmationMsg),
                  nzOkText: this.layoutService.translate('Yes'),
                  nzCancelText: this.layoutService.translate('No'),
                  nzOnOk: () => {
                    for (const key in itemsExceedQuantity) {
                      const lineNum = key.substring(key.lastIndexOf('|') + 1);
                      const quantity = itemsExceedQuantity[key];
                      const line = documentLines.Lines.find(
                        (l) =>
                          l.Properties.find(
                            (p) => p.Name === 'LineNum',
                          ).ValueAsObject.toString() === lineNum.toString(),
                      );
                      const quantityProp = line.Properties.find(
                        (p) => p.Name === 'Quantity',
                      );
                      quantityProp.ValueAsObject = quantity;

                      LayoutService.setValue(
                        quantityProp,
                        quantity,
                        this.layoutService,
                        this.recordModel,
                        line.Id,
                        documentLines.Id,
                        this.moduleStructure,
                        true,
                      );
                    }

                    this.doSubmit(
                      isDocuments,
                      fromApproval,
                      saveAsDraft,
                      copyFrom,
                      newVersion,
                      callback,
                    );
                  },
                  nzOnCancel: () => {
                    this.doSubmit(
                      isDocuments,
                      fromApproval,
                      saveAsDraft,
                      copyFrom,
                      newVersion,
                      callback,
                    );
                  },
                });
              },
              nzOnCancel: () => {
                this.submitting = false;
                this.submittingModel = false;
              },
            });
          } else if (
            itemsOutOfBase.length > 0 &&
            Object.keys(itemsExceedQuantity).length === 0
          ) {
            confirmationMsg = `Order contains Items ${itemsOutOfBase.join(
              ',',
            )} which are not present in the Quote - Would you like to Copy them over as well?`;
            this.modal.confirm({
              nzTitle: this.layoutService.translate(confirmationMsg),
              nzOkText: this.layoutService.translate('Yes'),
              nzCancelText: this.layoutService.translate('No'),
              nzOnOk: () => {
                this.doSubmit(
                  isDocuments,
                  fromApproval,
                  saveAsDraft,
                  copyFrom,
                  newVersion,
                  callback,
                );
              },
              nzOnCancel: () => {
                this.submitting = false;
                this.submittingModel = false;
              },
            });
          } else if (
            itemsOutOfBase.length === 0 &&
            Object.keys(itemsExceedQuantity).length > 0
          ) {
            confirmationMsg = `Items ${Object.keys(itemsExceedQuantity)
              .map((k) => k.split('|')[0])
              .join(',')} Exceeds the Quoted qty, Change Qty to Open Qty?`;
            this.modal.confirm({
              nzTitle: this.layoutService.translate(confirmationMsg),
              nzOkText: this.layoutService.translate('Yes'),
              nzCancelText: this.layoutService.translate('No'),
              nzOnOk: () => {
                for (const key in itemsExceedQuantity) {
                  const lineNum = key.substring(key.lastIndexOf('|') + 1);
                  const quantity = itemsExceedQuantity[key];
                  const line = documentLines.Lines.find(
                    (l) =>
                      l.Properties.find(
                        (p) => p.Name === 'LineNum',
                      ).ValueAsObject.toString() === lineNum.toString(),
                  );
                  const quantityProp = line.Properties.find(
                    (p) => p.Name === 'Quantity',
                  );
                  quantityProp.ValueAsObject = quantity;

                  LayoutService.setValue(
                    quantityProp,
                    quantity,
                    this.layoutService,
                    this.recordModel,
                    line.Id,
                    documentLines.Id,
                    this.moduleStructure,
                    true,
                  );
                }

                this.doSubmit(
                  isDocuments,
                  fromApproval,
                  saveAsDraft,
                  copyFrom,
                  newVersion,
                  callback,
                );
              },
              nzOnCancel: () => {
                this.doSubmit(
                  isDocuments,
                  fromApproval,
                  saveAsDraft,
                  copyFrom,
                  newVersion,
                  callback,
                );
              },
            });
          }
          if (confirmationMsg === '') {
            this.doSubmit(
              isDocuments,
              fromApproval,
              saveAsDraft,
              copyFrom,
              newVersion,
              callback,
            );
          }
        });
      }

      if (continueExecute) {
        this.doSubmit(
          isDocuments,
          fromApproval,
          saveAsDraft,
          copyFrom,
          newVersion,
          callback,
        );
      }

      /*const modStructDocument = this.moduleStructure.module.Sections.find(
        (x) => x.XmlTagName === 'Documents'
      );*/
    } else {
      this.doSubmit(
        isDocuments,
        fromApproval,
        saveAsDraft,
        copyFrom,
        newVersion,
        callback,
      );
    }
  }

  doSubmit(
    isDocuments,
    fromApproval = false,
    saveAsDraft = false,
    copyFrom = false,
    newVersion = false,
    callback?: (result) => boolean,
  ) {
    console.info('[SAP-LINE-ORDER]', 'Record submission dispatch', {
      isDocuments,
      newVersion,
      saveAsDraft,
      fromApproval,
      objectKey: this.recordModel?.ObjectKey || '',
    });
    this.submittingModel = true;
    if (
      !isDocuments ||
      fromApproval ||
      saveAsDraft ||
      (this.recordModel.EventType === EventType.Update && !newVersion)
    ) {
      const submitSub = this.layoutService
        .submitObject(
          this.recordModel,
          this.moduleStructure,
          newVersion,
          this.approvalTemplates,
          saveAsDraft,
        )
        .subscribe((d: any) => {
          this.submitting = false;
          this.submittingModel = false;
          if (callback != null) {
            const callBackResult = callback(d);
            if (!callBackResult) {
              return;
            }
          }

          if (d.Has_Error) {
            if (d.FromWarning !== true) {
              this.notificationService.error(
                this.layoutService.translate('Error'),
                d.Error_Message,
              );
            }
          } else {
            let keyToDisplay =
              this.recordModel.ObjectKey === 'oServiceCalls' ||
              d.DocumentNumber == null ||
              d.DocumentNumber === undefined ||
              d.DocumentNumber === 0
                ? d.Resault_Value
                : d.DocumentNumber;
            this.layoutService.recordModelChanged = false;
            this.notificationService.success(
              this.layoutService.translate('Success'),
              this.layoutService.translate(`Operation completed successfully`) +
                (keyToDisplay == null ? '' : ` , No. #${keyToDisplay}`),
            );

            /*console.log(
              'GoBackAfterCreate',
              this.moduleStructure.module.AdditionalInformationParsed
                .GoBackAfterCreate,
            );*/
            if (
              !fromApproval &&
              !saveAsDraft &&
              this.recordModel.EventType === EventType.Create &&
              this.moduleStructure.module.AdditionalInformationParsed
                .GoBackAfterCreate != null &&
              this.moduleStructure.module.AdditionalInformationParsed
                .GoBackAfterCreate !== undefined &&
              !this.moduleStructure.module.AdditionalInformationParsed
                .GoBackAfterCreate
            ) {
              this.objectSubmitted.emit(d.Resault_Value);
              if (
                !(
                  this.recordId == null ||
                  this.recordId === undefined ||
                  this.recordId === ''
                )
              ) {
                this.keyToDisplay =
                  this.recordModel.ObjectKey === 'oServiceCalls' ||
                  d.DocumentNumber == null ||
                  d.DocumentNumber === undefined ||
                  d.DocumentNumber === 0
                    ? d.Resault_Value
                    : d.DocumentNumber;

                this.isLoading = true;
                this.recordId = d.Resault_Value;
                this.loadRecordData();
              }
              if (
                this.recordModel.EventType == EventType.Create &&
                this.moduleStructure.module.AdditionalInformationParsed
                  .DisplaySuccessMessageAfterAdd
              ) {
                this.keyToDisplay =
                  this.recordModel.ObjectKey === 'oServiceCalls' ||
                  d.DocumentNumber == null ||
                  d.DocumentNumber === undefined ||
                  d.DocumentNumber === 0
                    ? d.Resault_Value
                    : d.DocumentNumber;

                this.recordId = d.Resault_Value;
                this.showSuccessArea = true;
              }
            } else if (
              g.loadDraftAfterCreate &&
              saveAsDraft &&
              this.recordModel.EventType == EventType.Create
            ) {
              const url = this.router.url;
              setTimeout(() => {
                this.router.navigate([
                  `/apps/${
                    url.indexOf('inventory') > -1 ? 'inventory' : 'crm'
                  }/module-list/${this.moduleId}/${this.moduleFilterId}`,
                  {
                    selectedId: d.Resault_Value,
                    fromDraft: true,
                    timeStamp: new Date().getTime(),
                    fromDoc: true,
                  },
                ]);
              }, 500);
            } else {
              if (
                this.recordModel.EventType == EventType.Create &&
                this.moduleStructure.module.AdditionalInformationParsed
                  .DisplaySuccessMessageAfterAdd
              ) {
                this.keyToDisplay =
                  this.recordModel.ObjectKey === 'oServiceCalls' ||
                  d.DocumentNumber == null ||
                  d.DocumentNumber === undefined ||
                  d.DocumentNumber === 0
                    ? d.Resault_Value
                    : d.DocumentNumber;
                this.recordId = d.Resault_Value;
                this.showSuccessArea = true;
                this.objectSubmitted.emit(d.Resault_Value);
                this.previewAfterCreate();
              } else if (
                this.recordModel.EventType == EventType.Update &&
                this.moduleStructure.module.AdditionalInformationParsed
                  .ReloadAfterUpdate === 'Y'
              ) {
                this.keyToDisplay =
                  this.recordModel.ObjectKey === 'oServiceCalls' ||
                  d.DocumentNumber == null ||
                  d.DocumentNumber === undefined ||
                  d.DocumentNumber === 0
                    ? d.Resault_Value
                    : d.DocumentNumber;
                this.recordId = d.Resault_Value;
                this.objectSubmitted.emit(d.Resault_Value);
                if (
                  !(
                    this.recordId == null ||
                    this.recordId === undefined ||
                    this.recordId === ''
                  )
                ) {
                  this.keyToDisplay =
                    this.recordModel.ObjectKey === 'oServiceCalls' ||
                    d.DocumentNumber == null ||
                    d.DocumentNumber === undefined ||
                    d.DocumentNumber === 0
                      ? d.Resault_Value
                      : d.DocumentNumber;
                  this.isLoading = true;
                  this.recordId = d.Resault_Value;
                  this.loadRecordData();
                }
              } else {
                this.keyToDisplay =
                  this.recordModel.ObjectKey === 'oServiceCalls' ||
                  d.DocumentNumber == null ||
                  d.DocumentNumber === undefined ||
                  d.DocumentNumber === 0
                    ? d.Resault_Value
                    : d.DocumentNumber;
                this.recordId = d.Resault_Value;
                this.previewAfterCreate();
                if (this.fromDoc) {
                  const url = this.router.url;
                  this.router.navigate([
                    `/apps/${
                      url.indexOf('inventory') > -1 ? 'inventory' : 'crm'
                    }/module-list/${this.moduleId}/${this.moduleFilterId}`,
                    {
                      fromDraft: false,
                      timeStamp: new Date().getTime(),
                    },
                  ]);
                } else {
                  this.objectSubmitted.emit(d.Resault_Value);
                  this.backButtonClicked.emit();
                }
              }
            }
          }
        });
      this.subscriptions.push(submitSub);
    } else {
      // if (
      //   this.recordModel.Categories.find((x) => x.Id === 'Document_Lines').Lines
      //     .length === 0
      // ) {
      //   this.notificationService.error(
      //     'No lines Added',
      //     'Please add lines to the document before submitting the document'
      //   );
      //   this.submitting = false;
      //   return;
      // }

      var docsToIgnoreCheckApproveFor = g.ignoreCheckApproveFor.split(',');

      if (
        docsToIgnoreCheckApproveFor.indexOf(this.recordModel.ObjectKey) !== -1
      ) {
        this.executeSubmit(saveAsDraft, newVersion, callback);
      } else {
        this.layoutService
          .checkObjectApprove(
            this.recordModel,
            this.moduleStructure,
            newVersion,
          )
          .subscribe((d: any) => {
            /*if (callback != null) {
            const callBackResult = callback(d);
            if (!callBackResult) {
              return;
            }
          }*/

            this.submitting = false;
            this.submittingModel = false;
            console.log(d);
            if (d.Has_Error) {
              if (d.FromWarning !== true) {
                this.notificationService.error(
                  this.layoutService.translate('Error'),
                  d.Error_Message,
                );
              }
            } else if (d.Resault_Value.HasApproval) {
              this.approvalTemplates = d.Resault_Value.Templates;
              console.log('templates', this.approvalTemplates);
              this.showApproveDrawer = true;
            } else {
              this.executeSubmit(saveAsDraft, newVersion, callback);
            }
          });
      }
    }
  }

  executeSubmit(
    saveAsDraft = false,
    newVersion = false,
    callback?: (result) => boolean,
  ) {
    this.submitting = true;
    this.submittingModel = true;
    const submitSub = this.layoutService
      .submitObject(this.recordModel, this.moduleStructure, newVersion)
      .subscribe((x: any) => {
        if (callback != null && !x.Has_Error) {
          if (!saveAsDraft && this.inDrawer) {
            this.backButtonClicked.emit();
          } /*else {*/
          this.keyToDisplay =
            this.recordModel.ObjectKey === 'oServiceCalls' ||
            x.DocumentNumber == null ||
            x.DocumentNumber === undefined ||
            x.DocumentNumber === 0
              ? x.Resault_Value
              : x.DocumentNumber;
          this.layoutService.recordModelChanged = false;
          this.recordId = x.Resault_Value;
          this.recordModel.KeyValue = this.recordId.toString();
          const callBackResult = callback(x);
          if (!callBackResult) {
            return;
          }
          //}
        }
        console.log('x', x);
        this.submitting = false;
        this.submittingModel = false;

        if (x.Has_Error) {
          if (x.FromWarning !== true) {
            this.notificationService.error(
              this.layoutService.translate('Error'),
              x.Error_Message,
            );
          }

          const callBackResult = callback(x);
          if (!callBackResult) {
            return;
          }
          return;
        } else {
          let keyToDisplay =
            this.recordModel.ObjectKey === 'oServiceCalls' ||
            x.DocumentNumber == null ||
            x.DocumentNumber === undefined ||
            x.DocumentNumber === 0
              ? x.Resault_Value
              : x.DocumentNumber;
          this.notificationService.success(
            this.layoutService.translate('Success'),
            this.layoutService.translate(`Operation completed successfully`) +
              ` , No. #${keyToDisplay}`,
          );
          this.layoutService.recordModelChanged = false;

          console.log(
            'GoBackAfterCreate',
            this.moduleStructure.module.AdditionalInformationParsed
              .GoBackAfterCreate,
          );

          let modulesToCheckAfterCreate =
            g.executeCustomActionAfterCreateForModules.split(',');
          let modulesToCheckAfterUpdate =
            g.executeCustomActionAfterUpdateForModules.split(',');

          if (
            this.recordModel.EventType === EventType.Create &&
            modulesToCheckAfterCreate.indexOf(
              this.moduleStructure.module.Id.toString(),
            ) !== -1
          ) {
            this.recordId = x.Resault_Value;
            this.recordModel.KeyValue = this.recordId.toString();

            RecordModel.ExecuteCustomAction(
              'AFTER_CREATE_' +
                this.moduleStructure.module.Id.toString() +
                '_' +
                x.Resault_Value,
              this.layoutService,
              this.recordModel,
              '',
              this.moduleStructure,
              this.drawerService,
              this,
              '',
              this.router,
              () => {},
            );

            this.objectSubmitted.emit(x.Resault_Value);
            return;
          }

          if (this.recordModel.EventType == EventType.Create) {
            if (!saveAsDraft && this.inDrawer) {
              this.keyToDisplay =
                this.recordModel.ObjectKey === 'oServiceCalls' ||
                x.DocumentNumber == null ||
                x.DocumentNumber === undefined ||
                x.DocumentNumber === 0
                  ? x.Resault_Value
                  : x.DocumentNumber;
              this.recordId = x.Resault_Value;
              this.objectSubmitted.emit(x.Resault_Value);
            } else if (
              this.moduleStructure.module.AdditionalInformationParsed
                .DisplaySuccessMessageAfterAdd
            ) {
              this.keyToDisplay =
                this.recordModel.ObjectKey === 'oServiceCalls' ||
                x.DocumentNumber == null ||
                x.DocumentNumber === undefined ||
                x.DocumentNumber === 0
                  ? x.Resault_Value
                  : x.DocumentNumber;
              this.recordId = x.Resault_Value;
              this.showSuccessArea = true;
              //this.objectSubmitted.emit(x.Resault_Value);
            } else if (
              saveAsDraft ||
              this.moduleStructure.module.AdditionalInformationParsed
                .GoBackAfterCreate == null ||
              this.moduleStructure.module.AdditionalInformationParsed
                .GoBackAfterCreate === undefined ||
              this.moduleStructure.module.AdditionalInformationParsed
                .GoBackAfterCreate
            ) {
              this.backButtonClicked.emit();
            } else {
              //this.objectSubmitted.emit(x.Resault_Value);
              this.keyToDisplay =
                this.recordModel.ObjectKey === 'oServiceCalls' ||
                x.DocumentNumber == null ||
                x.DocumentNumber === undefined ||
                x.DocumentNumber === 0
                  ? x.Resault_Value
                  : x.DocumentNumber;
              this.objectSubmitted.emit(x.Resault_Value);
              this.isLoading = true;
              this.recordId = x.Resault_Value;
              this.loadRecordData();
            }

            /*if (
              this.moduleStructure.module.AdditionalInformationParsed
                .EnableKanban
            ) {*/
            const args = {
              action: this.moduleStructure.module.ObjectType + '_afterAdd',
              module: this.moduleStructure.module,
              section: undefined,
              recordModel: undefined,
              recordId: x.Resault_Value,
              baseUrl: g.apiBaseUrl,
              suffixUrl: g.getUrlSuffix(),
            };

            const customEvent = new CustomEvent(
              'BWEBExecuteClientSideFuntion',
              {
                detail: args,
                bubbles: true,
                cancelable: false,
              },
            );

            document.dispatchEvent(customEvent);
            //}
          } else {
            if (
              this.moduleStructure.module.AdditionalInformationParsed
                .ReloadAfterUpdate === 'Y'
            ) {
              //this.objectSubmitted.emit(x.Resault_Value);
              if (
                !(
                  this.recordId == null ||
                  this.recordId === undefined ||
                  this.recordId === ''
                )
              ) {
                this.keyToDisplay =
                  this.recordModel.ObjectKey === 'oServiceCalls' ||
                  x.DocumentNumber == null ||
                  x.DocumentNumber === undefined ||
                  x.DocumentNumber === 0
                    ? x.Resault_Value
                    : x.DocumentNumber;
                this.objectSubmitted.emit(x.Resault_Value);
                this.isLoading = true;
                this.recordId = x.Resault_Value;
                this.loadRecordData();
              }
            } else {
              this.backButtonClicked.emit();
            }
          }

          /* if (
                  saveAsDraft ||
                  this.moduleStructure.module.AdditionalInformationParsed
                    .GoBackAfterCreate
                ) {
                  if (
                    this.recordModel.EventType == EventType.Create &&
                    this.moduleStructure.module.AdditionalInformationParsed
                      .DisplaySuccessMessageAfterAdd
                  ) {
                    this.recordId = x.Resault_Value;
                    this.showSuccessArea = true;
                    this.objectSubmitted.emit(x.Resault_Value);
                  } else {
                    this.backButtonClicked.emit();
                  }
                } else {
                  this.objectSubmitted.emit(x.Resault_Value);
                  if (
                    !(
                      this.recordId == null ||
                      this.recordId === undefined ||
                      this.recordId === ''
                    )
                  ) {
                    this.objectSubmitted.emit(x.Resault_Value);
                    this.isLoading = true;
                    this.recordId = x.Resault_Value;
                    this.loadRecordData();

                    if (
                      this.recordModel.EventType == EventType.Create &&
                      this.moduleStructure.module.AdditionalInformationParsed
                        .DisplaySuccessMessageAfterAdd
                    ) {
                      this.recordId = x.Resault_Value;
                      this.showSuccessArea = true;
                    }
                  }
                } */
        }
      });
    this.subscriptions.push(submitSub);
  }

  checkBaseTotalForDocuments(): boolean {
    let modules = g.checkBaseTotalForDocuments.split(',');
    let res = modules.indexOf(this.recordModel.ObjectKey) !== -1;
    return res;
  }

  checkItemsInBaseDocument(): boolean {
    let modules = g.checkItemsInBaseDocument.split(',');
    let actions = g.checkItemsInBaseDocumentForActions.split(',');
    let res =
      actions.indexOf(this.customActionCode) !== -1 &&
      modules.indexOf(this.recordModel.ObjectKey) !== -1;
    return res;
  }

  initObject() {
    if (this.moduleId.toString() === '2' && this.actionType === 'Add') {
      this.moduleStructure.module.Sections =
        this.moduleStructure.module.Sections.filter((section) => {
          return (
            section.XmlTagName !== 'BPActivities' &&
            section.XmlTagName !== 'BPLatestActivities' &&
            section.XmlTagName !== 'APActivities' &&
            section.XmlTagName !== 'APLatestActivities' &&
            section.XmlTagName !== 'BPQuotation' &&
            section.XmlTagName !== 'APQuotation' &&
            section.XmlTagName !== 'BPOrders' &&
            section.XmlTagName !== 'APOrders' &&
            section.XmlTagName !== 'BPInvoices' &&
            section.XmlTagName !== 'APInvoices' &&
            section.XmlTagName !== 'BPOpportunities' &&
            section.XmlTagName !== 'APGoods' &&
            section.XmlTagName !== 'BPServiceCall' &&
            section.XmlTagName !== 'Widget' &&
            section.XmlTagName !== 'BPServiceContracts' &&
            section.XmlTagName !== 'APLatestActivities' &&
            section.XmlTagName !== 'BPDeliveries' &&
            section.XmlTagName !== 'APLatestActivities' &&
            section.XmlTagName !== 'BPReturns' &&
            section.XmlTagName !== 'APReturns' &&
            section.XmlTagName !== 'BPCreditNotes' &&
            section.XmlTagName !== 'APCreditNotes' &&
            section.XmlTagName !== 'BPPayments' &&
            section.XmlTagName !== 'APPayments' &&
            section.XmlTagName !== 'Cust_State'
          );
        });
    }

    this.layoutService.triggerInitObject.emit({
      moduleStructure: this.moduleStructure,
      actionType: this.actionType,
    });
  }
  handlePOTextLines() {
    const linesCategory = this.recordModel.Categories.find(
      (x) => x.Id === 'ProductionOrders_Lines',
    );
    const textLines = linesCategory.Lines.filter(
      (x) =>
        x.Properties.find((z) => z.Name == 'ItemType').ValueAsObject == -18,
    );
    const newSpecLines = LayoutService.HardCopyObject(
      textLines.map((x) => {
        return {
          AftLineNum: x.Id - 1,
          LineSeq: 0,
          LineNumber: x.Id,
          LineText: x.Properties.find((z) => z.Name == 'LineText')
            .ValueAsObject,
          LineType: '-18',
        };
      }),
    );

    if (linesCategory.SpecialLines == null) linesCategory.SpecialLines = [];

    linesCategory.SpecialLines = [
      ...linesCategory.SpecialLines,
      ...newSpecLines,
    ];
    linesCategory.SpecialLines.sort((a, b) => a.AftLineNum - b.AftLineNum).map(
      (x, i) => {
        x.LineSeq = i;
        x.LineType = x.LineType == 'T' || x.LineType == '-18' ? '-18' : 'T';
      },
    );
    linesCategory.Lines = linesCategory.Lines.filter(
      (x) =>
        x.Properties.find((z) => z.Name == 'ItemType').ValueAsObject != -18,
    );
  }
  handleParentChanged() {
    this.subscriptions.push(
      this.layoutService.fieldValueChanged.subscribe(
        (args: FieldValueChangedArgs) => {
          if (
            this.recordModel === undefined ||
            args.recordProperty === undefined
          ) {
            return;
          }

          if (args.recordModel.FormGUID !== this.recordModel.FormGUID) {
            return;
          }

          const sectionOfField = args.moduleStructure.module.Sections.find(
            (d) => d.XmlTagName === args.sectionTagName,
          );

          const allFields = [].concat(
            ...args.moduleStructure.module.Sections.map(
              (section) => section.Fields,
            ),
          ) as Field[];

          const fieldOfField = allFields.find(
            (f) => f.Id === args.recordProperty.FieldId,
          );

          const recordCategoryOfField = args.recordModel.Categories.find(
            (d) => d.Id === args.sectionTagName,
          );
          const recordLineOfField = recordCategoryOfField.Lines.find(
            (l) => l.Id === args.line,
          );

          if (recordLineOfField === undefined) {
            return;
          }

          recordLineOfField.QuantityProp = recordLineOfField.Properties.find(
            (p) =>
              p.Name === 'Quantity' ||
              p.Name === 'UoMCountedQuantity' ||
              p.Name == 'PickedQuantity',
          );
          recordLineOfField.OpenQtyProp = recordLineOfField.Properties.find(
            (p) => p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity',
          );
          recordLineOfField.BaseItemCodeProp =
            recordLineOfField.Properties.find(
              //(p) => p.Name === 'ITM_BOM_BASE_BaseItem'
              (p) => p.Name === 'U_ITM_BWEB_PARENT_ITEM',
            );
          recordLineOfField.TreeTypeProp = recordLineOfField.Properties.find(
            (x) => x.Name === 'TreeType',
          );
          recordLineOfField.ItemCodeProp = recordLineOfField.Properties.find(
            (x) => x.Name === 'ItemCode',
          );

          if (
            sectionOfField.AdditionalInformationParsed.LineTemplate !== '' &&
            sectionOfField.AdditionalInformationParsed.LineTemplate != null &&
            sectionOfField.AdditionalInformationParsed.LineTemplate !==
              undefined
          ) {
            const template = Handlebars.compile(
              sectionOfField.AdditionalInformationParsed.LineTemplate,
            );
            const html = template(recordLineOfField);
            recordLineOfField.LineTemplateHtml = html;
            recordLineOfField.QuantityProp = recordLineOfField.Properties.find(
              (p) =>
                p.Name === 'Quantity' ||
                p.Name === 'UoMCountedQuantity' ||
                p.Name == 'PickedQuantity',
            );
            recordLineOfField.OpenQtyProp = recordLineOfField.Properties.find(
              (p) => p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity',
            );
          }

          //this.recordModel.Categories.forEach((recordCategory) => {
          for (let i = 0; i < this.recordModel.Categories.length; i++) {
            let recordCategory = this.recordModel.Categories[i];
            const sectionTagName = recordCategory.Id;
            if (sectionTagName === 'SpecialLines') {
              continue;
            }

            recordCategory.Lines.forEach((line) => {
              const lineId = line.Id;
              if (
                args.sectionTagName === sectionTagName &&
                args.line !== lineId
              ) {
                return;
              }

              line.Properties.forEach((recordProperty) => {
                const sections = this.moduleStructure.module.Sections.filter(
                  (s) => s.XmlTagName === sectionTagName,
                );

                let field: Field;
                sections.forEach((section) => {
                  // if (field !== undefined) {
                  //   return;
                  // }

                  const foundedField = section.Fields.find(
                    (f) => f.Id === recordProperty.FieldId,
                  );

                  if (foundedField !== undefined) {
                    field = foundedField;
                  }
                });

                if (field === undefined) {
                  console.log(
                    'We were not able to find the field of ' +
                      sectionTagName +
                      '.' +
                      recordProperty.Name,
                  );
                  return;
                }

                recordProperty.DataType = field.DataType;

                let queryIdToExecute = field.SQLStatementParentChanged;
                let queryParameters = [];
                if (queryIdToExecute == null || queryIdToExecute === 0) {
                  queryIdToExecute = field.SQLStatementId;
                }

                if (queryIdToExecute != null && queryIdToExecute !== 0) {
                  queryParameters = g.queriesData[queryIdToExecute];
                  if (queryParameters === undefined) {
                    queryParameters = [];
                  }
                }

                if (
                  (field.ParentProperties !== null &&
                    field.ParentProperties.split(';').indexOf(
                      `${args.sectionTagName}.${args.recordProperty.Name}`,
                    ) !== -1) ||
                  (queryParameters.indexOf(
                    `${args.sectionTagName}.${args.recordProperty.Name}`,
                  ) !== -1 &&
                    field.PropertyName !== args.recordProperty.Name)
                ) {
                  if (
                    fieldOfField.ParentProperties != null &&
                    fieldOfField.ParentProperties?.indexOf(
                      sectionTagName + '.' + field.PropertyName,
                    ) !== -1
                  ) {
                    fieldOfField.ParentProperties =
                      fieldOfField.ParentProperties.replace(
                        sectionTagName + '.' + field.PropertyName,
                        `$${sectionTagName + '$.$' + field.PropertyName}$`,
                      );

                    setTimeout(() => {
                      fieldOfField.ParentProperties =
                        fieldOfField.ParentProperties.replace(
                          `$${sectionTagName + '$.$' + field.PropertyName}$`,
                          sectionTagName + '.' + field.PropertyName,
                        );

                      console.log(
                        'Parent values returned to: ' +
                          fieldOfField.ParentProperties,
                      );
                    }, 500);
                  }

                  if (field.DataType === 3) {
                    RecordModel.getOptions(
                      field,
                      this.recordModel,
                      recordProperty,
                      sectionTagName,
                      line.Id,
                      recordCategory,
                      this.layoutService,
                      this.moduleStructure,
                    );

                    if (
                      field.SQLStatementParentChanged != null &&
                      field.SQLStatementParentChanged !== 0
                    ) {
                      recordProperty.DBValue = '';
                      recordProperty.ValueAsObject = '';

                      this.layoutService.getFieldValueOnParentChange(
                        this.recordModel,
                        recordCategory,
                        line,
                        recordProperty,
                        field.SQLStatementParentChanged,
                        field,
                        this.moduleStructure,
                        true,
                      );
                    }
                  } else {
                    if (queryIdToExecute != null && queryIdToExecute !== 0) {
                      this.layoutService.getFieldValueOnParentChange(
                        this.recordModel,
                        recordCategory,
                        line,
                        recordProperty,
                        queryIdToExecute,
                        field,
                        this.moduleStructure,
                        true,
                      );
                    }
                  }
                }
              });
            });
          }
          //});
        },
      ),
    );
  }
  closeApprovalDrawer() {
    this.showApproveDrawer = false;
  }

  previewAfterCreate() {
    if (
      this.moduleStructure.module.AdditionalInformationParsed
        .ExecuteViewRecordAfterAdd &&
      this.moduleStructure.module.LayoutDefinitionId != null &&
      this.moduleStructure.module.LayoutDefinitionId != 0
    ) {
      const url = `Report/PrintObject/${
        this.moduleStructure.module.LayoutDefinitionId
      }?selectedId=${
        this.recordId
      }&exportMode=5&mode=preview&${g.getUrlSuffix()}`;
      window.open(g.apiBaseUrl + url);
    }
  }
}
